<template>
    <div class="add-timesheets">
      <ob-layout :type="11">
        <template slot="title">
          <span @click="cancel()" style="color: rgb(49, 151, 235);  cursor: pointer;">{{ timesheetLabel }}</span>
          <span> <i style="font-size: 22px;margin: 0px 5px 15px;" class="fa fa-angle-right"></i></span>
          <span style="color: rgb(70, 68, 68); font-weight: 600;"> {{NAOrValue(timeSheetDetails, 'EmployeeName')}}'s {{ timesheetLabel }}(s)</span>
        </template>
        <template slot="body">
          <div class="add_timesheets-body">
            <div class="form-group row">
              <!-- <div class="col-md-12">
                <h5 style="font-weight:600">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.</h5>
              </div> -->
            </div>
            <div class="row">
                <div class="col-md-12">
                    <!-- <label style="color:#464444">Please choose an option to submit. </label> -->
                    <div class="row rowgap">
                        <div class="col-md-4">
                            <div class="form-group">
                              <div class="radio-inline">
                                <ob-radio name="SubmitType" val="TimesheetOnly" :disabled="!isExpensesDisabled" v-model="SubmitType"><span style="font-weight:600;font-size: 14px;">{{ timesheetLabel }} only</span></ob-radio>
                              </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                              <div class="radio-inline">
                                <ob-radio name="SubmitType" val="ExpensesOnly" :disabled="isExpensesDisabled" v-model="SubmitType" @change.native="OnselectedTimesheetType('ExpensesOnly')"><span style="font-weight:600;font-size: 14px;">Expenses only</span></ob-radio>
                              </div>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                              <div class="radio-inline" style="padding-left: 0;">
                                <ob-radio name="SubmitType"  val="TimesheetAndExpenses" :disabled="isTimesheetExpensesDisabled" v-model="SubmitType" @change.native="OnselectedTimesheetType('TimesheetAndExpenses')"><span style="font-weight:600;font-size: 14px;">{{ timesheetLabel }} & Expenses</span></ob-radio>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
            <div class="form-group row" >
              <div class="col-md-12 pL0">
                <div class="col-md-8 p0">
                  <div class="col-md-12">
                    <div class="col-md-6 pR0" style="margin-top: 10px;">
                     <p style="display: flex;flex-wrap: wrap;justify-content:space-between;margin-top: -8px;margin-bottom:0px" > <span>Project Title <span class="validation-star">*</span></span> <span><ob-checkbox style="display: inline-block;" :type="1" v-model="isChecked">Show only Ongoing projects</ob-checkbox></span></p>
                     <ob-select2 v-if="showProjectOptions" :options="projectListOptions" v-model="projectSelected"  :class="{ 'ob-vuelidate_input-error': $v.projectSelected.$error }"></ob-select2>
                      <span class="ob-vuelidate_error-msg" v-if="$v.projectSelected.$dirty && !$v.projectSelected.requiredIf">Please choose a project to proceed further</span>
                     <!-- <label class="static timesheet_lable"  :title="timeSheetDetails.ProjectName">{{NAOrValue(timeSheetDetails, 'ProjectName')}}</label> -->
                  </div>
                  <div class="col-md-6 pR0" style="margin-top:10px;margin-bottom:30px">
                     <p style="margin-top: -2px;">{{ timesheetLabel }} Range <span class="validation-star">*</span> ({{daysDifference}})</p>
                        <div class="row">
                        <div class="col-md-6 pR0">
                          <ob-date-time-picker ref="dateFrom" :key="Count" id="dateFrom" :options="DatePickerOptions" :inputvalue="dateFrom" @updated="(v) => this.dateFrom = v" :dpchange="onFromDateChange"  v-model.trim="dateFrom"  :class="{ 'ob-vuelidate_input-error': $v.dateFrom.$error }"></ob-date-time-picker>
                          <span class="ob-vuelidate_error-msg" v-if="$v.dateFrom.$dirty && !$v.dateFrom.required">Select From Date</span>
                        </div>
                        <div class="col-md-6 pR0" style="margin-left:-10px">
                          <ob-date-time-picker ref="dateTo" id="dateTo" :key="keyValueUpdate" :options="options4" :inputvalue="dateTo" @updated="(v) => this.dateTo = v" v-model.trim="dateTo"  :class="{ 'ob-vuelidate_input-error': $v.dateTo.$error }"></ob-date-time-picker>
                          <span class="ob-vuelidate_error-msg" v-if="$v.dateTo.$dirty && !$v.dateTo.required">Select To Date</span>
                        </div>
                      </div>
                     <!-- <label class="static timesheet_lable" >{{dateFrom}} to {{dateTo}} ({{daysDifference}})</label> -->
                  </div>
                  </div>
                  <div class="col-md-12">
                    <div class="col-md-6" >
                      <p style="color:#464444;">End-Client</p>
                      <label class="static timesheet_lable" style="margin-top:7px"  :title="timeSheetDetails.EndClientName">{{NAOrValue(timeSheetDetails, 'EndClientName')}}</label>
                    </div>
                    <div class="col-md-6">
                      <p>Submitted Date</p>
                      <label class="static timesheet_lable"  style="margin-top:7px"  :title="timeSheetDetails.SubmittedDate">{{NAOrValue(timeSheetDetails, 'SubmittedDate')}} </label>
                      <!-- <div v-if="isSubmitDateEdit"><ob-date-time-picker style="width: 160px;" :id="'date4'" :inputvalue="timeSheetDetails.SubmittedDate" :options="subDateOptions" @updated="(v) => this.timeSheetDetails.SubmittedDate = v" v-model="timeSheetDetails.SubmittedDate"></ob-date-time-picker></div>
                      <label v-else class="static timesheet_lable"  :title="timeSheetDetails.SubmittedDate">{{NAOrValue(timeSheetDetails, 'SubmittedDate')}} <span @click.stop="isSubmitDateEdit = true"><i class="fa fa-pencil image" aria-hidden="true" style="padding-left:4px;"></i></span></label> -->
                    </div>
                  </div>
                </div>
                <div class="col-md-4 pR0" style="margin-top: 10px;">
                  <div class="col-md-6 pR0 pL0" v-if="SubmitType != 'ExpensesOnly'">
                    <div class="col-md-3 m0 p0">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total-hours.svg`" style="margin-right: 10px;width: 40px;"/>
                    </div>
                    <div class="col-md-9 mL0 pR0" style="line-height: 20px;padding-left: 6px;">
                    <template v-if="DetailMode">
                        <label style="color:#464444 ; font-weight: 600;font-size: 16px"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label>
                    </template>
                         
                     <template v-else>
                       <a style="text-decoration: underline;font-size: 13px;font-weight: 700;" v-if="QuickModeTotalHours == '0h 0m'" @click="openTimeDistributionPopup()">Enter Total Time</a>
                        <label v-else style="color:#464444 ; font-weight: 600;font-size: 16px"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}


                           <span @click="openTimeDistributionPopup('EDIT')" style="background: rgb(49, 151, 235);
                                                                                  border-radius: 4px;
                                                                                  display: inline-block;
                                                                                  padding: 1px 4px;
                                                                                  margin-left: 10px;
                                                                                  cursor: pointer;
                                                                                  float: right;
                                                                                  color: white;">
                                                         <i class="fa fa-pencil" style="font-size: 14px;"></i>
                            </span>
                        </label>
                    </template>
                    <p class="total-hours" style="font-weight: 500;">Total Hours Worked</p>
                  </div>
                    <!-- <div class="col-md-9 mL0 pR0" style="line-height: 20px;padding-left: 6px;">
                      <ob-input @blur="sendHours()" v-number-only @keyup.enter.native="sendHours()"  v-model="directHoursEntered" style="width: 80%" v-if="isHoursEntered"></ob-input>
                      <label @mouseover="onHrsClick()" v-else style="color:#464444 ; font-weight: 600;font-size: 16px;cursor:pointer"> {{DetailMode ? TotalHoursWorked : QuickModeTotalHours}}</label>
                      <p style="font-weight: 500;">Total Hours Worked</p>
                    </div> -->
                  </div>
                  <div class="col-md-6 pL0 pR0" v-if="SubmitType != 'TimesheetOnly'">
                    <div class="col-md-3 m0 p0">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_expense.svg`" style="margin-right: 10px;width: 40px;"/>
                    </div>
                    <div class="col-md-9 mL0 pR0 " style="line-height: 20px;padding-left: 6px;">
                      <label style="color:#464444 ; font-weight: 600;font-size: 16px"> ${{Number((totalExpensesAmount).toFixed(2))}}</label><p style="font-weight: 500;">Total Expense(s)</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="timesheetAttachments && projectSelected != null && projectSelected != '' && projectSelected != undefined">
              <div class="col-md-12">
                <!-- <h5 style="font-weight:600;margin: 0;padding-top: 14px;">Please upload Client approved Timesheets.</h5> -->
              </div>
            </div>
            <div class="attachments_view" v-if="SubmitType != 'ExpensesOnly'">
            <template v-for="(item,index) in Attachments">
              <div class="attachments-view" style="margin-top: 10px;">
                <template>
                  <span>{{getFileName(item)}}</span>
                  <ob-popover trigger="click" :options="{placement: 'bottom'}">
                      <div class="popper" style="padding:0px">
                          <div style="padding:10px;">
                              <span :class="{'cursorCls': !isFileType(item)}" >
                                <span :class="{'hideShow': !isFileType(item)}" style="display:inline-block;padding-right:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/print_icon.jpg`" width="32" height="32" @click="printSingleDoc(item)" /></span>
                              </span>
                              <span style="display:inline-block;padding:0 5px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/download_icon.jpg`" width="31" height="32" @click="downloadSingleDoc(item)" /></span>
                              <span style="display:inline-block;padding-left:10px;cursor:pointer"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/view_icon.jpg`" width="32" height="32" @click="previewSingleDoc(item)" /></span>
                          </div>
                      </div>
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Css/Content/Images/vue/I-9/blue-pill.png`" width="15" height="15" slot="reference" style="cursor:pointer;display:inline-block;margin-left:10px" />
                  </ob-popover>
                </template>
                <span>
                  <span class="cross-mark" @click="removeAttachments(index)" style="font-size: 11px;" >&#10006;</span>
                </span>
              </div>
            </template>
             <div v-if="showAttachmentDiv">
                <ob-upload-attachment ref="upload" :key="iCounter" @error-msg="IsInvalidFile" @file-inProgress="InProgress" @file-complete="onuploadComplete" :validation="ValidationType" :end-point="EndPoint" :type="1" :IsFileExists="filename" :attach-file.sync="attachFile">
                  <template slot="file-text">
                    <i class="fa fa-cloud-upload" aria-hidden="true"></i>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Drag and Drop &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;OR&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; Choose File
                  </template>
                </ob-upload-attachment>
              </div>
              <div class="row" style="border-bottom: 1.5px dashed #d4cccc;">
                <div class="col-md-12" style="margin-bottom: 8px;padding-left:16px;padding-top: 10px;">
                  <a @click="onAddAtachment()">
                    <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_add.svg`" style="margin-right: 5px;"/>
                    <span style="color:#464444;font-weight: 600;">Add Client approved {{ timesheetLabel }}</span>
                  </a>
                </div>
                <div class="col-md-12" style="margin-bottom:10px;">
                  <span style="font-style: italic;color: #9f9f9f;">We accept either pdf, xls, xlsx, doc, docx, zip, images upto 25MB.</span><span class="validation-star" v-if="timesheetAttachments">*</span>
                </div>
                <div class="col-md-12" v-if="timesheetAttachments && projectSelected != null && projectSelected != '' && projectSelected != undefined" style="margin-bottom: 10px;">
                   <span class="ob-vuelidate_error-msg" style="padding-left: 5px"
                                v-if="isErrorMessageDisabled" >{{errorMessageFrmResponse}} </span>
                  <span class="ob-vuelidate_error-msg" v-else-if="isValidate">You cannot remove this document, as it's marked as mandatory</span>
                </div>
                <div class="col-md-12" style="margin-bottom: 10px;" v-else>
                   <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="isErrorMessageDisabled" >{{errorMessageFrmResponse}} </span>
                </div>
              </div>
            </div>
          </div>
          <template v-if="WorkSheets.length > 0 && SubmitType != 'ExpensesOnly'">
            <template v-if="DetailMode">
                <div class="daterange" v-for="(item,index) in WorkSheets">
                  <template :id="index">
                    <div class="row" v-if="(!item.IsWeekDay || (!AllowTimeSheetSubmissionOnHolidays && (item.DayType == 'FederalHoliday' || item.DayType == 'Holiday'))) || (!AllowTimeSheetSubmissionOnLeaves && (item.DayType == 'Leave'))">
                      <div class="col-md-12" >
                      <div class="col-md-10 disabled-day">
                        <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendar.svg`" style="margin-right: 10px;"/><span style="color:#333333;margin-right: 5px;">{{getDayFormat(item.Date)}}</span>
                         <span style="color:#8595A6">{{getDateFormat(item.Date)}}</span>
                         <span v-if="item.DayType === 'Leave'" class="leave-tag" style="color: #CF355F;">(On Leave)</span>
                      </div>
                       <div class="col-md-2 disabled-day">
                          <span style="margin-right: 10px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total_hrs.svg`" style="margin-left: 6px;margin-right: 10px;"/>{{WorkSheets[index].totalTime}}</span>
                          <i data-v-e4c5d918="" aria-hidden="true" class="fa fa-chevron-down"></i>
                      </div>
                      </div>
                  </div>   
                  <ob-collapse :type="7" :expand="true"  theme="default" v-else>
                    <template slot="collapse-title">
                      <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_calendar.svg`" style="margin-right: 10px;"/><span style="color:#333333;margin-right: 5px;">{{getDayFormat(item.Date)}}</span>
                      <span style="color:#8595A6">{{getDateFormat(item.Date)}}</span>
                      <span v-if="item.DayType === 'Leave'" class="leave-tag" style="color: #CF355F;">(On Leave)</span>
                    </template>
                    <template slot="collapse-title-right">
                      <span style="margin-right: 10px;"><img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_total_hrs.svg`" style="margin-right: 10px;"/>{{WorkSheets[index].totalTime}}</span>
                    </template>
                    <template slot="collapse-details">
                      <div>
                        <!-- <div class="col-md-12" style="padding:0 0 10px">
                          <span style="color:#F07431">{{holidayTypeDisplay(item)}}</span>
                        </div> -->
                        <div class="form-group row" style="border-bottom: 1.5px dashed #d4cccc;">
                          <div class="col-md-7" style="margin-right: 8px;">
                           <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_task-title.svg`" style="margin-right: 10px;"/><label style="color:#464444">Task Title</label><span v-if="isTaskMandatory" class="validation-star">*</span>
                          </div>
                          <div class="col-md-2 p0" style="margin-bottom: 10px;">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_duration.svg`" style="margin-right: 10px;"/><label style="color:#464444">Regular Time</label><span class="validation-star">*</span>
                          </div>
                          <div class="col-md-2 p0" style="margin-bottom: 10px;margin-left: 3px;" v-if="IsOverTimeApplicable">
                            <img :src="`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_duration.svg`" style="margin-right: 10px;"/><label style="color:#464444">Over Time</label>
                          </div>
                        </div>
                        <div class="row">
                          <div v-for="(task,Index) in item.tasksList" :key="Index">
                            <div class="form-group row">
                              <div class="col-md-12 pR0">
                                <div style="display:none;">{{task.Date = item.Date}}</div>
                                <div class="col-md-7" style="z-index: 0 !important;">
                                  <ob-select2 v-if="showTaskSelect2" :options="taskOptions" v-model="task.TaskId" :change="updateTaskList(task.TaskId, index, Index)"></ob-select2>
                                  <span v-if="$v.WorkSheets.$each[index].tasksList.$each[Index].TaskId.$error" class="ob-vuelidate_error-msg">Select task title</span>
                                </div>
                                <div class="col-md-2 p0" style="z-index: 0 !important;">
                                 <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="hrs" v-model="task.Hours" :change="select2close(index,Index,'RTH',task.Hours)" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index],task.Hours) ||  $v.WorkSheets.$each[index].tasksList.$each[Index].Hours.$error || compareMaxHours(WorkSheets[index],task.Hours) }"></ob-input>
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="mins" v-model="task.Minutes" :change="select2close(index,Index,'RTM',task.Minutes)" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index],task.Minutes) || $v.WorkSheets.$each[index].tasksList.$each[Index].Minutes.$error || compareMaxHours(WorkSheets[index],task.Minutes)}"></ob-input>
                                </div>
                                <div class="col-md-2 p0" style="z-index: 0 !important;" v-if="IsOverTimeApplicable">
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="hrs" v-model="task.OverTimeHours" :change="select2close(index,Index,'OTH',task.OverTimeHours)" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index],task.OverTimeHours) || $v.WorkSheets.$each[index].tasksList.$each[Index].OverTimeHours.$error }"></ob-input>
                                  <ob-input class="select2_style" :maxLength="2" v-number-only placeholder="mins" v-model="task.OverTimeMinutes" :change="select2close(index,Index,'OTM',task.OverTimeMinutes)" :class="{ 'ob-vuelidate_input-error': totalHoursvalidation(WorkSheets[index],task.OverTimeMinutes) || $v.WorkSheets.$each[index].tasksList.$each[Index].OverTimeMinutes.$error}"></ob-input>
                                </div>
                              </div>

                             <div class="col-md-12" v-if="task.TaskId != null && task.TaskId != ''">
                              <div class="col-md-7" style="padding-right: 7px;">
                                <textarea placeholder="Description" class="descriptn" :maxLength="500" v-model.trim="task.TaskDescription" @input="IsDescEdited(task.TaskId, task.TaskDescription, Index, index)"></textarea>
                              </div>
                            </div>                            
                            </div>
                          </div>
                           <div class="form-group row" style="margin-left: 2px;margin-bottom:0px;">
                             <div class="col-md-12 add_task">
                               <div v-if="compareMaxHours(WorkSheets[index],9)" style="padding-bottom:5px;">
                                <span v-if="IsPreviousRTHoursExist(WorkSheets[index])" class="ob-vuelidate_error-msg">
                                     As there are previously added {{ timesheetLabel.toLowerCase() }}(s) for this day, the total regular time exceeds {{MaximumRegulerTimesheetHours}} hours. Please verify
                                 </span>
                                <span v-else class="ob-vuelidate_error-msg">Please enter valid hours. Your employer has set the maximum regular time hour limit to {{MaximumRegulerTimesheetHours}} hours per day.</span>
                              </div>
                               <div v-else-if="totalHoursvalidation(WorkSheets[index],9)">
                                  <span class="ob-vuelidate_error-msg">The total work time cannot be more than 24 hours per day.</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </template>
                  </ob-collapse>
                </template>
              </div>
            </template>
            <!-- Planned Activities for Detail Mode -->
                        <div class="row" v-if="DetailMode" style="padding: 1%;margin-bottom: 20px;">
                          <div class="col-md-12">
                            <div class="form-group" style="margin-top: 20px;margin-bottom: -22px;">
                              <label>Planned activities for the next period</label>
                              <span v-if="isTaskMandatory" class="validation-star">*</span>
                              <ob-textarea
                                v-model.trim="plannedActivities"
                                placeholder="Type Here" :class="{ 'ob-vuelidate_input-error': $v.plannedActivities.$error }"/>
                              <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if=" $v.plannedActivities.$dirty && $v.plannedActivities.$error"> Please Enter Planned activities</span>
                            </div>
                          </div>
                        </div>
            <template v-else>
              <quick-mode-timesheets @totalHoursWorked="totalHoursWorkedQuickMode" ref="quicktimesheets" :WorkSheets.sync="QuickModeWorkSheets" :IsOverTimeApplicable="IsOverTimeApplicable" :AllowTimeSheetSubmissionOnHolidays.sync="AllowTimeSheetSubmissionOnHolidays" :orgName.sync="orgName"  :AllowTimeSheetSubmissionOnLeaves.sync = "AllowTimeSheetSubmissionOnLeaves"  :PreviousWorkHours.sync="PreviousWorkHours" :MaximumRegulerTimesheetHours.sync="MaximumRegulerTimesheetHours"></quick-mode-timesheets>
               <!-- Quick Mode Activities Fields -->
          <div class="row" v-if="!DetailMode" style="padding:1%">
            <div class="col-md-12">
          <div class="form-group" style="padding-top: 10px;" >
            <label>Current Period Activities</label>
            <span v-if="isTaskMandatory" class="validation-star">*</span>
            <ob-textarea
              v-model.trim="currentPeriodActivities"
              placeholder="Type Here" :class="{ 'ob-vuelidate_input-error': $v.currentPeriodActivities.$error }"/>
            <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.currentPeriodActivities.$dirty && $v.currentPeriodActivities.$error"> Please Enter Current Period Activities</span>
          </div>
          <div class="form-group">
            <label>Planned activities for the next period</label>
            <span v-if="isTaskMandatory" class="validation-star">*</span>
            <ob-textarea
              v-model.trim="plannedActivities"
              placeholder="Type Here"  :class="{ 'ob-vuelidate_input-error': $v.plannedActivities.$error }"/>
            <span class="ob-vuelidate_error-msg" style="padding-left: 5px" v-if="$v.plannedActivities.$dirty && $v.plannedActivities.$error"> Please Enter Planned activities</span>
          </div>
        </div>
          </div>
            </template>
          </template>

          <add-task :openModal.sync="openAddTaskPopup" :IsEdit ="isEdit" :PreviousData.sync ="previousData" @HandleAfterTaskUpdate="HandleAfterTaskUpdate"></add-task>


            <ob-modal2 :show.sync="showTimeDistributionPopup" :type="1" :backdrop="false" >
            <div  style="color: #143361;padding: 21px 15px;font-size: 16px;font-weight: 700;">Enter Total Time</div>
            <div class="col-md-12"> <strong>Total time will be distributed to selected date range <b>({{getDateFormat(dateFrom)}} - {{getDateFormat(dateTo)}}) </b> equally. However you can manually adjust based on your requirement</strong> </div>
            <div  style="padding:60px 15px;">
                <div class="col-md-6 p0" style="z-index: 0 !important;">
                    
                    <label style="color:#464444;display:block">Total Regular Time <span class="validation-star">*</span> </label>

                    <ob-input style="width:120px" class="select2_style"  v-number-only placeholder="Enter Hours" v-model="RegularDistributionHours" :class="{ 'ob-vuelidate_input-error': (CheckRegularDistributionHours && RegularDistributionHours > 0) || $v.RegularDistributionHours.$error}" ></ob-input>
                    <ob-input style="width:120px" :maxLength="2" class="select2_style"  v-number-only placeholder="Enter Minutes" v-model="RegularDistributionMinutes" :class="{ 'ob-vuelidate_input-error': (CheckRegularDistributionHours && RegularDistributionMinutes > 0) || $v.RegularDistributionMinutes.$error}"></ob-input>
                </div>
                <div class="col-md-6 p0" style="z-index: 0 !important;" v-if="IsOverTimeApplicable">
                    
                     <label style="color:#464444;display:block"> Total Over Time </label>

                    <ob-input style="width:120px"  class="select2_style" v-number-only placeholder="Enter Hours"  v-model="OverTimeDistributionHours" ></ob-input>
                    <ob-input style="width:120px" :maxLength="2" class="select2_style"  v-number-only placeholder="Enter Minutes" v-model="OverTimeDistributionMinutes" :class="{ 'ob-vuelidate_input-error': $v.OverTimeDistributionMinutes.$error}"></ob-input>
                </div>
            </div>
            <div style="padding:10px 15px;" v-if="(CheckRegularDistributionHours) ">
              <span v-if="PreviousWorkHours.length > 0" class="ob-vuelidate_error-msg">As there are previously added {{ timesheetLabel.toLowerCase() }}(s) for certain days, entered work distribution hours are exeeding the {{MaximumRegulerTimesheetHours}} hours per day. Please verify</span>
              <span v-else class="ob-vuelidate_error-msg">Entered work distribution hours are exeeding the {{MaximumRegulerTimesheetHours}} hours per day. Please enter valid hours. Your maximum regular work hour limit is {{MaximumRegulerTimesheetHours}} hours per day.</span>
            </div>
            <div>
                <ob-checkbox :disabled="true" v-if="this.$refs.quicktimesheets != undefined && this.$refs.quicktimesheets != null && this.$refs.quicktimesheets.weekendsList != null && this.$refs.quicktimesheets.weekendsList != ''" style="padding: 5px 30px 5px;" :type="1" v-model="showTimeDistributionPopup">Exclude {{this.$refs.quicktimesheets.weekendsList}} from distribution</ob-checkbox>
                <ob-checkbox v-else style="padding: 5px 30px 5px;margin-bottom:10px" :type="1" v-model="IsWeekendChecked">Exclude Saturday and Sunday from distribution</ob-checkbox>
          

<div class="col-md-12">
           <div class="col-md-12" style="background: rgb(74,144,226,0.1);padding: 15px;margin: 0px 0px 30px 0px;color: rgb(74,144,226);font-size: 12px;border-radius: 5px;" v-if="this.$refs.quicktimesheets != undefined && this.$refs.quicktimesheets != null && this.$refs.quicktimesheets.weekendsList != null && this.$refs.quicktimesheets.weekendsList != ''">
                  <div class="col-md-1 pL0" style="padding-right: 0;width:3%;" >
                    <img :src='`${CDNIMAGESBASEURL}/ess/ESSApp/static/Images/ic_bulb_line.svg`' style="width:12px;border-radius:50%;">
                  </div>
                  <div class="col-md-11 pL0">
                    <span style="font-weight:600;padding-left:0px;font-size: 12px;"> As per your employer, you cannot add {{ timesheetLabel.toLowerCase() }} for <span >  {{this.$refs.quicktimesheets.weekendsList}} </span> . Please reach out to your employer to enable this option.</span>
                  </div>
                  </div> 
                  </div>       
            </div>
            <div  style="padding: 0px 20px 20px 20px;text-align:center;">
                <ob-button style="width: 120px;"  type="secondary" @click="OnDistributionPopupCancel()">Cancel</ob-button>
                <ob-button style="width: 120px;" @click="OnDistributionHoursEnter()">Distribute</ob-button>
            </div>
        </ob-modal2>
        <div class="row" v-if="projectSelected != null && projectSelected != '' && projectSelected != undefined  && SubmitType != 'ExpensesOnly'" style="padding:1%; margin-top: -30px;">
             <div class="col-md-12">
               <div class="form-group">
               <label>Comments</label>
               <ob-textarea :maxLength="150"  v-model.trim="Comments" placeholder="Enter Comments"></ob-textarea>
               </div>
              </div>
            </div>
           <timeSheet-expenses ref="timesheetExpenses" @expensesAmount="expensesAmount" v-if="WorkSheets.length > 0 && SubmitType != 'TimesheetOnly'" @isValidExpenses="isValidExpenses" :TimeSheetdateFrom.sync="dateFrom" :TimeSheetdateTo.sync="dateTo" :ExpenseModel.sync="ExpenseModel"></timeSheet-expenses>
           <reject-timesheet :openRejectPopup.sync="openRejectPopup" :selectedReport.sync="selectedReport" :fromTab="''" :SubmitType="SubmitType"></reject-timesheet>
           <evaluation-popup :openEvalutionPopup.sync="openEvalutionPopup" :selectedReport.sync="selectedReport" :TimesheetType="SubmitType"></evaluation-popup>
           <evaluation-rating :EvaluationStatus="timeSheetDetails.EvaluationStatus" :selectedReport.sync="selectedReport" :openModal.sync="openEvaluationRating"></evaluation-rating>
           <evaluation-report :iframeURL="iframeURL" :selectedReport.sync="selectedReport" :openModal.sync="openEvaluationReport"  ></evaluation-report>
        </template>
        <template slot="footer">
           <!-- <ob-button  @click="cancel()">cancel</ob-button> -->
          <ob-button :disabled="!IsValidHours"  @click="isValid()">Approve</ob-button>
          <ob-button :disabled="!IsValidHours" type="secondary" @click="openRejectPopup = true">Reject</ob-button>
        </template>
      </ob-layout>
    </div>
</template>
<script>
import c from 'Vue/Core/constants.js'
import utils from "Vue/Core/utils.js";
import CommonFunctionMixin from '../../CommonFunctionMixin'

import RejectTimeSheet from '../../RejectTimeSheet.vue'
import TimeSheetExpenses from './EmployerEditExpanses.vue';
import QuickModeTimesheets from '../../QuickModeTimesheets.vue';
import EvaluationPopup from './EvaluationPopup.vue';

import EvaluationRating  from './../../EvaluationReport.vue'

import EvaluationReport from '../../ApprovalReport.vue'
import AddTask from  "@/components/ESSProfile/Tasks/AddTask.vue";


import jquery from "jquery";
import {required, minLength, maxLength, requiredIf, email, alpha, minValue, maxValue} from 'vuelidate/lib/validators';
export default {
  mixins: [CommonFunctionMixin],
  props:["TimesheetId","timesheetEmployeeId","selectedReport","fromTab","TimesheetOrExpense"],
  data(){
    return{
      Comments:'',
      PreviousWorkHours:[],
      keyValueUpdate:0,
      TimesheetProjectList:[],
      isChecked : false,
      OkGotIt:false,
      IsWeekendChecked:false,
      RegularDistributionHours:'',
      RegularDistributionMinutes:'',
      OverTimeDistributionHours:'',
      OverTimeDistributionMinutes:'',
      showTimeDistributionPopup:false,
      IsSunday: false,
      IsMonday : true,
      IsTuesday : true,
      IsWednesday  :true,
      IsThursday  : true,
      IsFriday  : true,
      IsSaturday  : false,
      IsAllowFutureDate:false,
      currentPeriodActivities: '',
      plannedActivities: '',
      backUpdata:[],
      TimeSheetStatus:'',
      showProjectOptions:false,

      AllowTimeSheetSubmissionOnHolidays: false,
      AllowTimeSheetSubmissionOnLeaves: false,

      directHoursEntered:"",
      isHoursEntered : false,
      isTaskMandatory :false,
      iCounter:'',
      isErrorMessageDisabled:false,
      errorMessageFrmResponse:'',
      openEvaluationReport:false,
      iframeURL:'',
      openEvaluationRating:false,
      openEvalutionPopup:false,
      openRejectPopup:false,
      TimesheetEmployeeId:'',
      isSubmitDateEdit:false,
      SubmittedDate:'',
      ExpenseModel:[],
      QuickModeTotalHours:0,
      QuickModeWorkSheets:[],
      DetailMode:true,
      projectList:[],
      projectSelected:'',
      timesheetCycle:'',
      timesheetAttachments:'',
      IsOverTimeApplicable:false,
      showTaskSelect2:true,
      IsWorkingDaysAvailable: false,
      coinsideDateFrom:'',
      coinsideDateTo:'',
      timesheetId:'',
      timeSheetDetails:[],
      Hours:'',
      Minute:'',
      WorkSheets:[ ],
      workingDaysList:[],
      totalTime:'',
      showAttachmentDiv:false,
      showProjectTitle: false,
      ProjectTitleList: '',
      taskTitleList:'',
      dateArray:[],
      dateFrom:'',
      dateTo:'',
      tasksList:[{
        ProjectId:'',
        TaskId:'',
        Date:'',
        Hours:'',
        Minutes:'',
        TaskDescription:'',
        IsTaskEdited:false
      }],
      totalExpensesAmount:0,
      isExpensesValid:false,
      subDateOptions:{
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        maxDate : moment().format('MM/DD/YYYY'),
        widgetPositioning: {
          horizontal: 'left',
          vertical: 'bottom'
        }
      },
      options4: {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        //maxDate : moment().add(1,'months'),
        maxDate: false,
        widgetPositioning: {
          horizontal: 'right',
          vertical: 'bottom'
        }
      },
      projectOptions: {
        placeholder: {
          id: "-1",
          text: "Select"
        },
        data: [
        ]
      },
      // projectListOptions:{
      //   placeholder: {
      //     id: "-1",
      //     text: "Select"
      //   },
      //   data: [
      //   ],
      // },
      taskOptions: {
        data: [],
        placeholder: {
              id: '-1',
              text: 'Please select '
          },
      tags: true,
      insertTag: function (data, tag) {
          if (tag.text === '') {
              tag = null
          }
          if(data.length < 1 || data == undefined){
              tag = {
                  id: tag.text,
                  text: tag.text,
                  newTag: true
              }
              data.push(tag);
          }
      },
      templateResult: function(data) {
          var result = '';
          if(data.newTag != true){
              result+='</p></div></div><div><p style="font-size:12px;color:#143361;font-weight:550;">' + data.text + '</p></div></div>'
          }
          else{
              result += '<div class="select"><div style="float:left;padding-right:2px"><div><img style="height:30px;width:30px;background-color: white;border-radius:50%;":src="'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_add.svg"></div></div><div></div>'
              result +=  '<div style="display:inline-block"><div style="overflow: hidden:"><p style="font-size:12px;color:#143361;font-weight:550;overflow-x:hidden;">'+ data.text +'</p><span style="font-size:9px;">Will be added to Tasks</span></div></div></div>'
              data.newTag = false;
          }
          return jquery(result);
      }
      },
      isValidate:false,
      docUrl:'',
      Attachments:[],
      ValidationType:{
      Rules: {
        Type: ["pdf", "zip", "xls", "xlsx", "doc", "docx", "png", "jpng" , "gif", "jpg", "jpeg"],
        Size: 26000000,
        multiplefiles:true
      },
      Messages: {
        Type: "Please upload valid file formats",
        Size: `Please upload a file which is less than 25MB`,
      },
      excludeList:false
      },
      filename:[],
      EndPoint: `${c.APIBASEURL}/File/FileUpload`,
      attachFile:false,
      NewlyAddedTaskList:[],
      MaximumRegulerTimesheetHours:0,
      SubmitType:'TimesheetOnly',
      Count:0,
      ProjectEndDate:'',
      ExpenseStatus:'',

      
      openAddTaskPopup: false,
      isEdit:false,
      previousData:[]

    }
  },
  validations() {
    return {
        RegularDistributionHours:{
           requiredIf:requiredIf((d) => {
            if(this.RegularDistributionMinutes != null && this.RegularDistributionMinutes != ''){
              return false
            }else{
              return true
            }
          }),
          minValue:minValue(0)
      },
      RegularDistributionMinutes:{
        requiredIf:requiredIf((d) => {
                    if(this.RegularDistributionHours != null && this.RegularDistributionHours != ''){
                      return false
                    }else{
                      return true
                    }
                  }),
                  minValue:minValue(0),
                  maxValue:maxValue(59)
      },
      OverTimeDistributionMinutes:{
                  minValue:minValue(0),
                  maxValue:maxValue(59)
      },
      "dateFrom":{
        required
      },
      "dateTo":{
        required
      },
      "currentPeriodActivities": {
        required
      },
      "plannedActivities": {
        required
      },
      "projectSelected":{
        requiredIf: requiredIf((a) => {
          if (this.projectList != '' && this.projectList != null){
            return true
          }else{
            return false
          }
        })
      },
      WorkSheets:{
        $each:{
            'tasksList': {
              $each:{
               "Hours" : {
                  requiredIf:requiredIf((d) => {
                    if(d.Minutes != null && d.Minutes != ''){
                      return false
                    }else{
                      return true
                    }
                  }) ,
                  minValue:minValue(0),
                  maxValue:maxValue(24)
               },
               "Minutes" : {
                  requiredIf:requiredIf((d) => {
                    if(d.Hours != null && d.Hours != ''){
                      return false
                    }else{
                      return true
                    }
                  }),
                  minValue:minValue(0),
                  maxValue:maxValue(59)
                },
                "TaskId" : {
                  requiredIf:requiredIf((d) => {
                    if(d.TaskId != null || !this.isTaskMandatory){
                      return false
                    }else{
                      return true
                    }
                  }),
                },
                "OverTimeHours":{
                  minValue:minValue(0),
                  maxValue:maxValue(24)
                },
                "OverTimeMinutes":{
                  minValue:minValue(0),
                  maxValue:maxValue(59)
                }
              }
            }
        }
      }
    }
  },
  components: {
     "timeSheet-expenses":TimeSheetExpenses,
     "quick-mode-timesheets":QuickModeTimesheets,
     "reject-timesheet" : RejectTimeSheet,
     "evaluation-popup":EvaluationPopup,
     "evaluation-rating":EvaluationRating,
     "evaluation-report":EvaluationReport,
     "add-task" : AddTask,
  },
  watch:{
    isChecked(val){
      this.showProjectOptions = false
      this.getProjectOptionList()
    },
    openModal(val) {
      this.show = val;
    },
    show(val) {
      this.$emit('update:openModal', val)
    },
    TimesheetId(val)
    {
      if(val != null && val != '' )
      {
        this.TimesheetEmployeeId = this.timesheetEmployeeId
        this.timesheetId = val;
        this.getTimesheetDetails()
      }
    },
    dateFrom(val)
    {
      if(val != null && this.dateTo != null && val != '')
      {
        setTimeout(() => {
          // this.$refs.dateTo.data.minDate(val)
          this.options4.minDate = moment(val).format('MM/DD/YYYY')
          this.keyValueUpdate++;
        }, 100)
        this.callDateRange()
        this.fromDateValidation()
      }
    },
    dateTo(val)
    {
      if(val != null && this.dateFrom != null && val != '')
      {
        setTimeout(() => {
          this.DatePickerOptions.maxDate = moment(val).format('MM/DD/YYYY')
          this.Count++;
        }, 100)
        this.callDateRange()
        this.fromDateValidation("dateTo")
        //this.updateToDatePicker(this.dateFrom)
      }
    },
    projectSelected(val)
    {
      if(val != null && val != '')
      {
        this.onProjectSelected(val);
      }
    },
  },
  computed: {
    IsValidHours()
    {
      if(this.SubmitType == 'TimesheetOnly')
      {
        return true;
        // if(this.TotalTimesheetHours != undefined && this.TotalTimesheetHours != '0h 0m')
        // {
        //   return true;
        // }
      }
      else if(this.SubmitType == 'ExpensesOnly')
      {
         if(this.totalExpensesAmount != undefined && this.totalExpensesAmount != 0)
         {
          return true
         }
      }
      else if(this.SubmitType == 'TimesheetAndExpenses')
      {
        if((this.TotalTimesheetHours != undefined && this.TotalTimesheetHours != '0h 0m') && (this.totalExpensesAmount != undefined && this.totalExpensesAmount != 0))
        {
          return true;
        }
      }
      return false;
    },
    TotalTimesheetHours()
    {

      return this.DetailMode ? this.TotalHoursWorked : this.QuickModeTotalHours
    },
    isExpensesDisabled(){
      if(this.TimesheetOrExpense == 'timesheet'){
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.SubmitType = 'TimesheetOnly'
        return true
      }
      else{
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.SubmitType = 'ExpensesOnly'
        return false
      }
    },
    isTimesheetExpensesDisabled(){
      if(this.timeSheetDetails.TimeSheetStatus == "Approved"|| this.timeSheetDetails.TimeSheetStatus == "Rejected" || this.ExpenseStatus == "Approved"|| this.ExpenseStatus == "Rejected"){
        return true
      }
      else return false
    },
     projectListOptions(){ 
      var options = {}
        options.placeholder= {
          id: '-1', // the value of the option
          text: 'Select'
        }
      var data = this.TimesheetProjectList.filter(l => l.ProjectId != '')
      options.data = data
      var template = function(data) {
        let result = '';
        if(data.id != 'Project unavailable'){
          result += '<div style="width:200px"><div class="row "><div class="col-md-12"><div style="font-weight: 600;font-size: 15px;width: 180px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">'+data.ProjectTitle+'</div></div></div>'
          result += '<div class="row" style="padding-top:10px"><div class="col-md-6">'+'<img :src="'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_endclient.svg" style="width:15px;margin-bottom:4px;float:left"/>'+'<div style="padding-left:5px;width: 70px;white-space:nowrap;text-overflow: ellipsis;overflow: hidden;">'+data.EndClientName+'</div>'+'</div><div style="float:left;height:15px;width:1px;background-color:gray"></div><div class="col-md-5">'+data.Status+'</div></div>'
          result += '<div class="row" style="padding-top:10px"><div class="col-md-12">'+'<img :src="'+c.CDNIMAGESBASEURL+'/ess/ESSApp/static/Images/ic_projectperiod.svg" style="width: 15px;margin-bottom:4px"/>'+'<span style="padding-left:5px">'+data.StartDate +" to "+data.EndDate +'</span>'+'</div></div></div>'
        }else{
          result += '<div style="width:200px"><div class="row "><div class="col-md-12"><div style="font-weight: 600;font-size: 15px;width: 180px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;">'+"Project unavailable"+'</div></div></div>'
        }
        return $(result);
      }
      options.templateResult = template
      return options;
    },
    daysDifference()
    {
      var start = moment(this.dateFrom, "MM/DD/YYYY");
      var end = moment(this.dateTo, "MM/DD/YYYY");
      let x =  moment.duration(end.diff(start)).asDays()+1;

      if(parseInt(x) > 1)
      {
       return  x + ' days'
      }
      else if(parseInt(x) == 1){
       return x + ' day'
      }

    },
    attachmentCount(){
      if(this.Attachments.length > 0)
        return this.Attachments.length
    },
    AlertProjectId()
    {
      if(this.$route.query.startDate != null && this.$route.query.endDate != null && this.$route.query.project != null )
      {
        var project = this.projectList.filter(v=>v.ProjectId == this.$route.query.project)[0]
        return project.ProjectId
      }
    },
    TotalHoursWorked()
    {
      var hrs = 0 ;
      var min = 0
      for(var i=0 ; i < this.WorkSheets.length ; i++)
      {
         var total = (this.WorkSheets[i].totalTime).split(' ')
         if(total[0]){
           var h = total[0]
           var m = total[1]
           if(h){
           hrs = hrs + parseInt(h.replace("h ",""))
          }if(m){
            min = min + parseInt(m.replace("m",""))
          }
       }
      }
      var hours = (min / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      var totalHours = parseInt(hrs) + parseInt(rhours)
      let _totalhoursWorked =  totalHours +"h " + rminutes + "m";
      this.QuickModeTotalHours = _totalhoursWorked
      return _totalhoursWorked;
    },
    diasbleApprovalButton()
    {
      if(this.IsCoincide == true)
      {
        return true
      }
      else return false
    },
    OrganisationId(){
      return this.loggedInUserObj.orgId ? this.loggedInUserObj.orgId : '';
    },
    projectsCount(){
      if(this.projectList && this.projectList != null && this.projectList.length > 1)
      {
        return this.projectList.length
      }
    },

    DatePickerOptions()
    {
      let options = {
        format: 'MM/DD/YYYY',
        dayViewHeaderFormat: 'MM/DD/YYYY',
        maxDate: moment(),
        widgetPositioning: {
          horizontal: 'auto',
          vertical: 'bottom'
          }
        }
      var project = [];
      if(this.projectList.length > 0)
      {
        project = this.projectList.filter(v=>v.ProjectId == this.projectSelected)[0]
          if (project != "" && project != null) {
          var projectStartDate = moment(project.ProjectStartDate);
          var fromMinDate;
          if(this.employmentStartDate) {
            var employmentStartDate = moment(this.employmentStartDate)
            fromMinDate = employmentStartDate.isBefore(projectStartDate) ? projectStartDate : employmentStartDate
          }
          else {
            fromMinDate = projectStartDate
          }
          setTimeout(() => {
            if (!this.IsAllowFutureDate) {
            this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
            }
            else if(this.IsAllowFutureDate){
            this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
            }
          }, 600)
        }
        else {
          setTimeout(() => {
            this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
          }, 100)
        }
      }
      else {
          setTimeout(() => {
            this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
          }, 100)
      }
      return options
    },
    CheckRegularDistributionHours(){
      var sheets=this.QuickModeWorkSheets
      var count = 0
      var min=0;
      var hrs=0;
      for( var i=0 ; i<this.QuickModeWorkSheets.length ; i++){
        var weekday=sheets[i]
        for(var j=0 ;j < weekday.length ; j++){
          if(weekday[j].IsWeekDay == true){
            var y;
            let preHrs;
            var previousRTWorkHours = this.PreviousWorkHours.find(v=>v.Date == weekday[j].Date) ? this.PreviousWorkHours.find(v=>v.Date == weekday[j].Date).RegularHours : "0h";
            y = previousRTWorkHours.split(' ');
            preHrs = y[0]? parseInt(y[0].replace("h ","")):"0";
            let preMin = y[1] ? parseInt(y[1].replace("m","")):"0";
            hrs = parseInt(hrs) + parseInt(preHrs);
            min  = parseInt(min) + parseInt(preMin);
            count= count +1
          }
        }
      }
      var limit=count*(this.MaximumRegulerTimesheetHours)
      if(this.RegularDistributionMinutes!=''){
        min=parseInt(min)+parseInt(this.RegularDistributionMinutes)
      }
      if(this.RegularDistributionHours!=''){
        hrs=parseInt(hrs)+parseInt(this.RegularDistributionHours)
      }
      var hours = (min / 60);
      var rhours = Math.floor(hours);
      var minutes = (hours - rhours) * 60;
      var rminutes = Math.round(minutes);
      var totalHours = parseInt(hrs)+parseInt(rhours);
      var totalminutes = (parseInt(totalHours) * 60 || 0) + (parseInt(rminutes) || 0)
      if(this.MaximumRegulerTimesheetHours==0){
        return false
      }
      // else if((totalminutes==limit) && rminutes >0 ){
      //   return true
      // }
      else if(totalminutes> limit){
        return true
      }
      else {
        return false
      }
    },
  },
  created(){
    this.timesheetId = this.TimesheetId
    this.TimesheetEmployeeId = this.timesheetEmployeeId
    setTimeout(() => {
       this.getTimesheetDetails()
      this.getTaskList()
    },200)
    this.getTimeSheetSettings()
  },
  methods:{
    IsDescEdited(TaskId, desc, taskIndex, sheetIndex){
      for (var i = 0; i < this.WorkSheets.length; i++) {
        for (var j = 0; j < this.WorkSheets[i].tasksList.length; j++) {

          if(this.WorkSheets[i].tasksList[j].TaskId == TaskId)
          {
            this.WorkSheets[i].tasksList[j].TaskDescription = desc;
            this.WorkSheets[i].tasksList[j].IsTaskEdited = true;
          }
        }
      }
      this.taskOptions.data.forEach((t) => {
          if (t.id == TaskId) {
            t.description = desc ;
          }
        })
    },
    editTask(obj){
      var taskId = obj.TaskId
      var empId = this.TimesheetEmployeeId 
      
      this.$loading({loadingText: 'Please wait...'});
      ajax.get(`/Task/${taskId}/${empId}`, {}, (res) => { 
        if(res.data.State == true){
          this.previousData = res.data.TaskMetaData;
          this.previousData['EmployeeId'] = empId;

          this.previousData['IsDisableUpdate'] = this.$route.name == 'employer-timesheets' || this.$route.name == "employer-addtimesheets" | (this.$route.query && this.$route.query.from == 'employer-timesheets') || (this.$route.query && this.$route.query.from == 'employer-addtimesheets') ||
                                                (this.previousData.CreatedBy != null && this.previousData.CreatedBy.Email == this.loggedInUserObj.email) ? false : true;
          //this.previousData.CurrentRole == 'HRManager' 
        }
        this.isEdit = true
        this.openAddTaskPopup = true
        this.$loading({}).close();
      })
    },
    HandleAfterTaskUpdate(val){
      this.showTaskSelect2 = false
      if(this.taskOptions != null && this.taskOptions.data != null && val != null)
      {
        var index = this.taskOptions.data.findIndex(x=>x.id == val.TaskId);
       
        this.taskOptions.data[index].text = val.Title;
 
        setTimeout(() => {
            this.showTaskSelect2 = true
          }, 10)
      }
    },

    updateTaskList(title, sheetIndex, taskIndex){
      if(title && title != null && title != ''){
        var isTaskExists = false
        this.taskOptions.data.forEach((t) => {
          if(t.id == title){
            isTaskExists = true
            return;
          }
        })
        if(isTaskExists == false){
          this.$loading({'loadingText': 'Loading...'})
          // this.taskOptions.data.push({'id': title, 'text' : title})
          this.bindingReqObjectForAddTask(title,sheetIndex, taskIndex)
          this.showTaskSelect2 = false
          setTimeout(() => {
            this.$loading({'loadingText': 'Loading...'}).close()
            this.showTaskSelect2 = true
          }, 1000)
        }
        else{
        //  this.WorkSheets[sheetIndex].tasksList[taskIndex].IsTaskEdited = false
          var task = this.taskOptions.data.find(x=>x.id == title);
          this.WorkSheets[sheetIndex].tasksList[taskIndex].TaskDescription =  task.description 
        }     
      } 
    },
    onProjectSelected(projectName)
    {
      var project = this.projectList.filter(v=>v.ProjectId == projectName)
      if(projectName != this.AlertProjectId)
      {
        if(project.length > 0){
          if(this.timesheetId == null || this.timesheetId == "" || this.timesheetId == undefined)
          {
            this.dateFrom = project[0].FromDate;
            this.PreviousDate = this.dateFrom;
            this.dateTo =  project[0].ToDate;
            this.ProjectEndDate = project[0].ProjectEndDate
          }
        }
        else{
          if(this.timesheetId == null || this.timesheetId == "" || this.timesheetId == undefined){
            this.dateFrom = '';
            this.dateTo = '';
            this.WorkSheets.length = 0;
          }
        }
      }
      else{
      //  this.projectSelected =  project.ProjectId
        this.dateFrom = this.$route.query.startDate;
        this.dateTo =  this.$route.query.endDate;
        this.timesheetCycle = project.TimeSheetCycle;

        // this.IsSunday = project.IsSunday;
        // this.IsMonday = project.IsMonday;
        // this.IsTuesday = project.IsTuesday;
        // this.IsWednesday  = project.IsWednesday;
        // this.IsThursday  = project.IsThursday;
        // this.IsFriday  = project.IsFriday;
        // this.IsSaturday  = project.IsSaturday;
        this.IsAllowFutureDate = project.AllowFutureDatesInTimesheets;
        this.isTaskMandatory = project.MandateTasksInTimesheets;
        this.MaximumRegulerTimesheetHours=project.MaximumRegulerTimesheetHours;
        this.ProjectEndDate = project.ProjectEndDate
      }
      if(project.length > 0){
        this.timesheetCycle = project[0].TimeSheetCycle;
        this.timesheetAttachments = project[0].IsClientAttachmentsRequired;
        this.IsOverTimeApplicable = project[0].IsOverTimeApplicable;

        //  this.IsSunday = project[0].IsSunday;
        // this.IsMonday = project[0].IsMonday;
        // this.IsTuesday = project[0].IsTuesday;
        // this.IsWednesday  = project[0].IsWednesday;
        // this.IsThursday  = project[0].IsThursday;
        // this.IsFriday  = project[0].IsFriday;
        // this.IsSaturday  = project[0].IsSaturday;
        this.IsAllowFutureDate = project[0].AllowFutureDatesInTimesheets;
        this.isTaskMandatory = project[0].MandateTasksInTimesheets;
        this.MaximumRegulerTimesheetHours=project[0].MaximumRegulerTimesheetHours;
        this.ProjectEndDate = project[0].ProjectEndDate
      }
      this.PreviousDate = this.dateFrom;
      if (this.timesheetCycle === "Custom" && project.length > 0) {
        this.PreviousDate = project[0].FromDate;
      }
      this.onProjectChangeDataUpdate()
      setTimeout(() => {
        this.DatePickerOptions.maxDate = moment().format('MM/DD/YYYY');
        if(!this.IsAllowFutureDate){          
        this.DatePickerOptions.maxDate = moment().format('MM/DD/YYYY');
        var today = moment().format('MM/DD/YYYY');
        if(today < this.dateFrom){
          this.DatePickerOptions.maxDate = this.dateFrom;
        }
        this.options4.maxDate = moment().format('MM/DD/YYYY');
        }
          this.Count++;
          this.keyValueUpdate++;
        }, 100)
      this.updateToDatePicker(this.dateFrom);
    },
    
     updateToDatePicker(fromDate)
    {
      var FromDate = moment().format('MM/DD/YYYY');
      var maxDt;
      var minDt;
      let projectEndDate = this.ProjectEndDate ? moment(this.ProjectEndDate) : moment().add(1, 'years'); 
      if(!this.IsAllowFutureDate)
      {
      if(this.timesheetCycle == 'Weekly' || this.timesheetCycle == 'None')
      {
        var x = moment().startOf('week').format('MM/DD/YYYY');
        maxDt = moment(x).add(6, 'days').format('MM/DD/YYYY');
        minDt = x;
      }
      else if (this.timesheetCycle == 'BiWeekly') {
        const weekStart = moment().startOf('week'); 
        minDt = weekStart.format('MM/DD/YYYY');
        maxDt = weekStart.add(13, 'days').format('MM/DD/YYYY'); 
      }        
        else if (this.timesheetCycle == 'SemiMonthly') {
        const currentDayNo = parseInt(moment().format('DD'));

        if (currentDayNo <= 15) {
          minDt = moment().startOf('month').format('MM/DD/YYYY'); // 1st of month
          maxDt = moment().startOf('month').add(14, 'days').format('MM/DD/YYYY'); 
        } else {
          minDt = moment().startOf('month').add(15, 'days').format('MM/DD/YYYY'); 
          maxDt = moment().endOf('month').format('MM/DD/YYYY'); // end of month
        }
      }
      else if (this.timesheetCycle == 'Monthly') {
        minDt = moment().startOf('month').format('MM/DD/YYYY');
        maxDt = moment().endOf('month').format('MM/DD/YYYY'); 
      }
      else if (this.timesheetCycle == 'Custom') {
          var x = moment(this.PreviousDate).format('MM/DD/YYYY');
          maxDt = moment(this.PreviousDate).add(1, 'months').format('MM/DD/YYYY');
          minDt = x;
      }
      else{
        maxDt = moment().add(1, 'months');
      }
      var date1 = new Date(this.ProjectEndDate)
      var date2 = new Date(maxDt)
      if(date1<date2){
        setTimeout(() => {
          this.DatePickerOptions.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
          this.options4.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
          this.Count++;
          this.keyValueUpdate++;
        }, 100)
        if(new Date(this.ProjectEndDate) < new Date(this.dateFrom)){
           this.dateFrom = this.ProjectEndDate
        }
        if(new Date(this.ProjectEndDate) < new Date(this.dateTo)){
           this.dateTo = this.ProjectEndDate
        }
      }
      else{
        setTimeout(() => {
            // this.$refs.dateTo.data.maxDate(maxDt)
            // this.$refs.dateFrom.data.maxDate(maxDt)
          this.options4.maxDate = maxDt
          this.Count++;
          this.keyValueUpdate++;
          }, 600)
      }
       }
      else
      {
        var date1 = new Date(this.ProjectEndDate)
        var date2 = new Date()
        if(date1<date2){
        setTimeout(() => {
          this.DatePickerOptions.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
          this.options4.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY')
          this.Count++;
          this.keyValueUpdate++;
        }, 100)
        if(new Date(this.ProjectEndDate) < new Date(this.dateFrom)){
           this.dateFrom = this.ProjectEndDate
        }
        if(new Date(this.ProjectEndDate) < new Date(this.dateTo)){
           this.dateTo = this.ProjectEndDate
        }
      }
        else{
          setTimeout(() => {
          // this.$refs.dateTo.data.maxDate(moment())
          // this.$refs.dateFrom.data.maxDate(moment())
          if(!this.IsAllowFutureDate){
          this.DatePickerOptions.minDate = null; 
          this.options4.minDate = null;
          }
          if (this.ProjectEndDate) {
            this.DatePickerOptions.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY');
            this.options4.maxDate = moment(this.ProjectEndDate).format('MM/DD/YYYY');
          } else {
            this.DatePickerOptions.maxDate = projectEndDate.format('MM/DD/YYYY');
            this.options4.maxDate = projectEndDate.format('MM/DD/YYYY');
          }
          this.Count++;
          this.keyValueUpdate++;
        }, 100)
        }

      }
    },
      getProjectOptionList(){ 
    

     let OngoingList = []
      for (var i = 0; i < this.projectList.length; i++)
        if (this.projectList[i].Status === "On-Going") {
            OngoingList.push(this.projectList[i]);
        }

      if(!this.isChecked){
        var finalProjectList = [...this.projectList]
      }
      else{
        if(OngoingList.length == 0){
          this.projectSelected = ''
        }
        finalProjectList = [...OngoingList]
      }
      this.TimesheetProjectList = __.map(finalProjectList, (c) => {
        return {
          "id" : c.ProjectId,
          "text":c.ProjectTitle,
          "ProjectTitle":c.ProjectTitle,
          "EndClientName":c.EndClientName,
          "Status":c.Status,
          "StartDate": c.ProjectStartDate ,
          "EndDate": c.ProjectEndDate,
        }
      })
       this.TimesheetProjectList.unshift({ id: 'Project unavailable', text: 'Project unavailable' ,
        "ProjectTitle":'',
        "EndClientName":'',
        "Status":'',
        "StartDate": '',
        "EndDate":''
      });

        setTimeout(() => {
        this.showProjectOptions = true
      }, 10)
    },
     onFromDateChange(e) {
      if(e.date != false)
      {
        setTimeout(() => {
          //this.$refs.dateTo.data.minDate(e.date)
          this.options4.minDate = moment(e.date).format('MM/DD/YYYY')
          this.keyValueUpdate++;
        }, 100)
        //this.updateToDatePicker(e.date);
      }
    },
     OnDistributionPopupCancel()
    {
      this.$v.RegularDistributionHours.$reset()
      this.$v.RegularDistributionMinutes.$reset()
      this.$v.OverTimeDistributionMinutes.$reset()

      this.RegularDistributionHours = '',
      this.RegularDistributionMinutes = '',
      this.OverTimeDistributionHours = '',
      this.OverTimeDistributionMinutes = '',
      this.showTimeDistributionPopup = false
    },
     openTimeDistributionPopup(val)
    {
      var quickList =  this.$refs.quicktimesheets.QuickTimesheetList;
      if(val == 'EDIT')
      {
         var regularMins = 0
        var OverMins = 0
      for(var i = 0 ; i < quickList.length ; i ++)
      {
        var item = quickList[i];
        for(var j=0 ; j < item.length ; j++)
        {
          let x = item[j];
          if(x.tasksList.Hours != '' && x.tasksList.Minutes != null){
            regularMins = (parseInt(regularMins) || 0) + (60 * parseInt(x.tasksList.Hours) || 0) + (parseInt(x.tasksList.Minutes) || 0) ;
          }
          if(x.tasksList.OverTimeHours != '' && x.tasksList.OverTimeMinutes != null){
            OverMins = (parseInt(OverMins) || 0) + (60 * parseInt(x.tasksList.OverTimeHours) || 0)  + (parseInt(x.tasksList.OverTimeMinutes) || 0) ;
          }
        }
      }

        var totalRegularMinutes = regularMins;
        this.RegularDistributionHours = Math.floor(totalRegularMinutes / 60);  
        this.RegularDistributionMinutes = parseInt(totalRegularMinutes % 60);

        var totalOverMinutes = OverMins;
        this.OverTimeDistributionHours = Math.floor(totalOverMinutes / 60);  
        this.OverTimeDistributionMinutes = parseInt(totalOverMinutes % 60);
      }
      else
      {
        this.RegularDistributionHours = '',
        this.RegularDistributionMinutes = '',
        this.OverTimeDistributionHours = '',
        this.OverTimeDistributionMinutes = '';
      }

      this.showHoursEnterPopover = false;
      this.showTimeDistributionPopup = true;
    },
    OnDistributionHoursEnter(val)
    { 
        this.$v.RegularDistributionHours.$touch();
        this.$v.RegularDistributionMinutes.$touch();
        this.$v.OverTimeDistributionMinutes.$touch();
       
        if(!this.$v.RegularDistributionHours.$error && !this.$v.RegularDistributionMinutes.$error && !this.$v.OverTimeDistributionMinutes.$error && !this.CheckRegularDistributionHours)
        {
           var regularMin = (parseInt(this.RegularDistributionHours) * 60 || 0) + (parseInt(this.RegularDistributionMinutes) || 0);
            var overtimeMins = (parseInt(this.OverTimeDistributionHours) * 60 || 0) + (parseInt(this.OverTimeDistributionMinutes) || 0);
            if(!this.IsQuickMode && (regularMin > 0 || overtimeMins > 0)){
              this.$refs.quicktimesheets.minsAutoFill(regularMin,overtimeMins);
            }
            this.OnDistributionPopupCancel();
        }
    },
    onHrsClick(){
      if(this.dateFrom != "" && this.dateTo !="" && !this.DetailMode){
        this.isHoursEntered = true
      }
    },
    sendHours(){
        if(!this.IsQuickMode && this.directHoursEntered != ''){
        this.$refs.quicktimesheets.hoursAutoFill(this.directHoursEntered);
        this.isHoursEntered = false;
        }
    },
    NewlyAddedTasklist()
    {
        let workItemTaksIds = this.WorkSheets.map(v=>v.tasksList).flat().map(v=>v.TaskId).filter(v=>v != null)
        let TaksIds = this.taskTitleList.map(v=>v.TaskId)

        let newTaskIds = workItemTaksIds.filter( function( el ) {
                  return TaksIds.indexOf( el ) < 0;
                  });

        return  newTaskIds
    },
    IsNewTaskAdded()
    {
        if(this.NewlyAddedTasklist().length > 0)
        {
          return true
        }
        else{
        return false
        }
    },
    IsEmployerUpdated(){
      if(this.projectSelected != this.timeSheetDetails.ProjectSelected)
      {
        return true
      }
      let workSheets = [];
      for(var i = 0 ; i < this.WorkSheets.length ; i ++)
      {
        for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j++)
        {
          if(this.WorkSheets[i].tasksList[j].IsTaskEdited)
          {
            return true;
          }
          this.WorkSheets[i].tasksList[j].ProjectId = this.projectSelected
          workSheets.push(this.WorkSheets[i].tasksList[j])
        }
      }

      let oldHoursList = this.timeSheetDetails.WorkSheets.map(v=>v.Hours);
      let newHoursList = workSheets.map(v=>v.Hours);

      let oldMinList = this.timeSheetDetails.WorkSheets.map(v=>v.Minutes);
      let newMinList = workSheets.map(v=>v.Minutes);

      let oldOTHoursList = this.timeSheetDetails.WorkSheets.map(v=>v.OverTimeHours);
      let newOTHoursList = workSheets.map(v=>v.OverTimeHours);

      let oldOTMinList = this.timeSheetDetails.WorkSheets.map(v=>v.OverTimeMinutes);
      let newOTMinList = workSheets.map(v=>v.OverTimeMinutes);

      let oldTaskIdList = this.timeSheetDetails.WorkSheets.map(v=>v.TaskId);
      let newTaskIdList = workSheets.map(v=>v.TaskId);

      let oldTimesheetAttachements = []
      if(this.timeSheetDetails.Attachments != null && this.timeSheetDetails.Attachments != undefined){
        oldTimesheetAttachements = this.timeSheetDetails.Attachments ;
      }
      let newTimesheetAttachements = this.Attachments ;

      let x = false;

      if(oldTimesheetAttachements.length == newTimesheetAttachements.length)
      {
          for(var t=0 ; t<oldTimesheetAttachements.length ; t++)
          {
            if(oldTimesheetAttachements[t] != newTimesheetAttachements[t])
            {
                x = true;
                break
            }
          }
      }
      else{
          return true
      }
      if(!x && this.SubmitType != 'TimesheetOnly')
      {

        let newExpenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
        let oldExpenseModel = [];
        if(this.timeSheetDetails.ExpenseDetailModel.ExpenseModel != undefined && this.timeSheetDetails.ExpenseDetailModel.ExpenseModel != null){
          oldExpenseModel = this.timeSheetDetails.ExpenseDetailModel.ExpenseModel
        }
        if(newExpenseModel.length == oldExpenseModel.length)
        {
            for(var t=0 ; t< newExpenseModel.length ; t++)
            {
              if(newExpenseModel[t].ExpenseType != oldExpenseModel[t].ExpenseType)
              {
                  x = true;
                  break
              }
              if(newExpenseModel[t].ExpenseAmount != oldExpenseModel[t].ExpenseAmount)
              {
                  x = true;
                  break
              }
              if(newExpenseModel[t].ExpenseDetails != oldExpenseModel[t].ExpenseDetails)
              {
                  x = true;
                  break
              }
              if(newExpenseModel[t].FromDate != oldExpenseModel[t].FromDate)
              {
                  x = true;
                  break
              }
              if(newExpenseModel[t].ToDate != oldExpenseModel[t].ToDate)
              {
                  x = true;
                  break
              }
              if(newExpenseModel[t].PaymentType != oldExpenseModel[t].PaymentType)
              {
                  x = true;
                  break
              }
            }
        }
        else{
          return true
        }
      }
      if(!x)
      {
        for(var t=0 ; t<workSheets.length ; t++)
        {
          if(oldHoursList[t] != newHoursList[t])
          {
              x = true;
              break
          }
          if(oldMinList[t] != newMinList[t])
          {
              x = true;
              break
          }
          if(oldOTHoursList[t] != newOTHoursList[t])
          {
              x = true;
              break
          }
          if(oldOTMinList[t] != newOTMinList[t])
          {
              x = true;
              break
          }
          if(oldTaskIdList[t] != newTaskIdList[t])
          {
              x = true;
              break
          }
        }
      }
      if(x)
      {
        return true
      }
      else{
        return false
      }
    },
    OnEvaluationRatingPopupClased()
    {
        this.openEvalutionPopup = false;
        this.openEvaluationRating = false;
        this.openEvaluationReport = true;
    },
    onEvalutionReportClose()
    {
        this.iframeURL = '';
        this.openEvalutionPopup = false;
        this.openEvaluationReport = false;
        this.openEvaluationRating = false;
    },
    OnOpenEvaluationRating()
    {
      this.openEvaluationReport = false;
      this.openEvaluationRating = true;
    },
    IsPreviousHoursExist(worksheets)
    {
      var x = this.PreviousWorkHours.find(v=>v.Date == worksheets.Date) ? this.PreviousWorkHours.find(v=>v.Date == worksheets.Date).Hours : "0h";
      if(x != '0h')
       return true;
    },
    compareMaxHours(worksheet , val){
      var hrs = 0 ;
      var min = 0;
      var h = parseInt(val) ? parseInt(val) : '0';
      if(worksheet.totalTime != '')
       {
        for(var i =0 ;i <worksheet.tasksList.length ; i++){
          var timesheet=worksheet.tasksList[i];
          if(timesheet.Hours == ''){
            hrs=hrs+0
          }
          else{
            hrs=hrs+parseInt(timesheet.Hours)
          }
          if(timesheet.Minutes == ''){
            min=min+0
          }
          else{
            min=min+parseInt(timesheet.Minutes)
          }
        }
        var previousRTWorkHours = this.PreviousWorkHours.find(v=>v.Date == worksheet.Date) ? this.PreviousWorkHours.find(v=>v.Date == worksheet.Date).RegularHours : "0h";
        var y = previousRTWorkHours.split(' ');
        let preHrs = 0;
        let preMin = 0;
        if(y.length == 2){
          preHrs = y[0] ? parseInt(y[0].replace("h ","")):"0";
          preMin = y[1] ? parseInt(y[1].replace("m","")):"0";
        }
        else if(y.length == 1){
          if (y[0].includes('h')) {
            preHrs = preHrs + (parseInt(y[0].replace('h', '')) || 0);
				  }
          else if (y[0].includes('m')) {
            preMin = preMin + (parseInt(y[0].replace('h', '')) || 0);
				  }
				}
        hrs = hrs +parseInt(preHrs) ;
        min  = min + parseInt(preMin);
        var hours = (min / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        var totalHours = parseInt(hrs) + parseInt(rhours);
        if(this.MaximumRegulerTimesheetHours==0){
          return false
        }
        else if(totalHours==this.MaximumRegulerTimesheetHours && rminutes >0 && h > 0){
         return true
        }
        else if((totalHours>this.MaximumRegulerTimesheetHours) && h > 0 ){
         return true
        }
        else {
         return false
        }
      }
    },
    IsPreviousRTHoursExist(worksheets){
      var x = this.PreviousWorkHours.find(v=>v.Date == worksheets.Date) ? this.PreviousWorkHours.find(v=>v.Date == worksheets.Date).RegularHours : "0h";
      if(x != '0h')
       return true;
    },
    totalHoursvalidation(worksheets,val)
    {
     if(worksheets != undefined && worksheets != null && worksheets.totalTime != null && worksheets.totalTime != undefined)
     {
          var time = worksheets.totalTime;

           var x = time.split(' ');
           var h = parseInt(val) ? parseInt(val) : '0';


          let hrs = parseInt(x[0].replace("h ",""));

          let min  = parseInt(x[1].replace("m",""));


          var total = parseInt(x[0]+x[1])
          if(hrs > 24 && h>0 )
          {
            return true
          }
          else if(hrs == 24 && min > 0 && h > 0)
          {
            return true
          }
          else return false
     }
    },
    expensesAmount(expenseamount){
      this.totalExpensesAmount = expenseamount;
    },
    isValidExpenses(expensesValid){
      this.isExpensesValid = expensesValid
    },
    totalHoursWorkedQuickMode(time)
    {
         this.QuickModeTotalHours = time;
    },
    // on DetailMode toggle click--converting quick mode data to detail mode
    FormatWorkItemsForDetailMode()
    {
      var quickList =  this.$refs.quicktimesheets.QuickTimesheetList;
      var detailModeList = [];
      Array.prototype.forEach.call(quickList, item => {
        Array.prototype.forEach.call(item, x => {

          if(!x.isDisabled)
          {
            var obj = {
              "Date": x.Date,
              "DayType": x.DayType,
              "totalTime": x.totalTime,
              "tasksList": [
                {
                  "Date": x.tasksList.Date,
                  "Hours": x.tasksList.Hours,
                  "Minutes": x.tasksList.Minutes,
                  "OverTimeHours": x.tasksList.OverTimeHours,
                  "OverTimeMinutes": x.tasksList.OverTimeMinutes,
                  "ProjectId": x.tasksList.ProjectId,
                  "TaskId": x.tasksList.TaskId,
                  "TaskDescription":x.tasksList.TaskDescription,
                  "IsTaskEdited":x.IsTaskEdited
                },
              ],
              "IsWeekDay":x.IsWeekDay,
              "show":true,
            }
            detailModeList.push(obj)
          }
        })
      })
      this.WorkSheets = [...detailModeList]
      this.caliculateTotalTime();
    },
    // on QuickMode toggle click--converting Detail mode data to Quick mode
    FormatWorkItemsForQuickMode()
    {
     //get dates for Disabled Dates
      var datefrom = moment(this.dateFrom).format('MM/DD/YYYY');
      var dateTo =  moment(this.dateTo).format('MM/DD/YYYY');
      const week_start_date = moment(datefrom).startOf('week').format('MM/DD/YYYY');
      const week_end_date = moment(dateTo).endOf('week').format('MM/DD/YYYY');
      var fromDateDiffList = this.EnumerateDaysBetweenDates(moment(week_start_date), moment(datefrom).add(-1, 'days'));
      var toDateDiffList = this.EnumerateDaysBetweenDates(moment(dateTo).add(1, 'days'), moment(week_end_date));
      var totalRemainedDaysArrayList = fromDateDiffList.concat(toDateDiffList);

      var totalRemainedDWorkItemList = [];
      Array.prototype.forEach.call(totalRemainedDaysArrayList, item => {
        var task1 = { ProjectId: '', TaskId: '', TaskDescription: '', IsTaskEdited:false, Date: '', Hours: '', Minutes: '', OverTimeHours: '', OverTimeMinutes: '' }
        let localObj = {
          Date : item,
          DayType : 'None',
          totalTime : '0 Hours',
          tasksList :task1,
          isDisabled : true,
          show:true,
          IsWeekDay:false
        }
        totalRemainedDWorkItemList.push(localObj);
      })
      //formating Existing Workitems as Quick list
      var ExistingWorkItems = [];

      Array.prototype.forEach.call(this.WorkSheets, item => {

        let H = 0;
        let M = 0;
        let OTH = 0;
        let OTM = 0;
        Array.prototype.forEach.call(item.tasksList, task => {
          H = H + (parseInt(task.Hours) || 0);
          M = M + (parseInt(task.Minutes) || 0);
          OTH = OTH + (parseInt(task.OverTimeHours) || 0);
          OTM = OTM + (parseInt(task.OverTimeMinutes) || 0);
        });

        let hours = (M / 60);
        let rhours = Math.floor(hours);
        let minutes = (hours - rhours) * 60;
        let rminutes = Math.round(minutes);
        let totalHours = parseInt(H) + parseInt(rhours);
        if(this.timesheetId == '' || this.timesheetId == null)
        {
        totalHours = totalHours == 0 ? '': totalHours;
        rminutes = rminutes == 0 ? '': rminutes;
        }

        let OThours = (OTM / 60);
        let OTrhours = Math.floor(OThours);
        let OTminutes = (OThours - OTrhours) * 60;
        let OTrminutes = parseInt(Math.round(OTminutes)) || 0;
        let OTtotalHours = parseInt(OTH) + parseInt(OTrhours) || 0;
        if(this.timesheetId == '' || this.timesheetId == null)
        {
        OTtotalHours = OTtotalHours == 0 ? '': OTtotalHours;
        OTrminutes = OTrminutes == 0 ? '': OTrminutes;
        }

        var task = { ProjectId: '', TaskId: '',TaskDescription: '', IsTaskEdited:false, Date: item.Date, Hours: totalHours.toString(), Minutes: rminutes.toString(), OverTimeHours: OTtotalHours.toString(), OverTimeMinutes: OTrminutes.toString() }

        let obj = {
          Date : item.Date,
          DayType : item.DayType,
          totalTime : '0 Hours',
          tasksList : task,
          isDisabled : false,
          show:true,
          IsWeekDay:item.IsWeekDay
        }
        totalRemainedDWorkItemList.push(obj);
      });
      var quickWorkSheets = totalRemainedDWorkItemList.sort(function(a,b){
        return new Date(a.Date) - new Date(b.Date); })

      this.QuickModeWorkSheets = [];

      /// converting as double array list(calender view)
      let i = 0;
      let j = 0;
      for (i = 0; i < quickWorkSheets.length; i++) {
        var x = [];
        for (j = 0; j < 7; j++) {
          x.push(quickWorkSheets[i]);
          i++;
        }
        i--;
        this.QuickModeWorkSheets.push(x);
      }
    },
    EnumerateDaysBetweenDates(startDate, endDate) {
      var now = startDate, dates = [];
      while (now.isSameOrBefore(endDate)) {
        dates.push(now.format('MM/DD/YYYY'));
        now.add(1, 'days');
      }
      return dates;
    },
    validateAttachments(){
      if(this.timesheetAttachments){
        if(this.attachmentCount > 0){
          this.isValidate = false
        }else{
          this.isValidate = true
        }
      }else{
        this.isValidate = false
      }
    },
    holidayTypeDisplay(type){
      if(type.DayType == 'FederalHoliday'){
        return `Note: This day has been declared as a federal holiday by your organization. However, you can add a ${this.timesheetLabel.toLowerCase()} for this day.`
      }
      else if (type.DayType == 'Holiday'){
        return `Note: This day has been declared as Organization holiday by your Employer. However, you can add a ${this.timesheetLabel.toLowerCase()} for this day.`
      }
      else if (type.DayType == 'Leave'){
        return `Note: You have an approved leave for this day. However, you can add a ${this.timesheetLabel.toLowerCase()} for this day.`
      }
    },
    getProjectList(){
      this.$loading({'loadingText': 'Loading...'})
      ajax.get(`TimeSheets/GetOfferDetails?empId=${this.TimesheetEmployeeId}`, {} ,(res) => {
        if(res.data.State == true){
          
          this.projectList = res.data.ProjectList
          this.AllowTimeSheetSubmissionOnHolidays = this.projectList != null && this.projectList.count != 0 && this.projectList[0] != null ? this.projectList[0].AllowTimeSheetSubmissionOnHolidays: false;
          var project = this.projectList.filter(v=>v.ProjectId == this.projectSelected)[0]
         if(project != null && project != '')
         {
          this.showProjectOptions = false;

          this.timesheetCycle = project.TimeSheetCycle;
          this.timesheetAttachments = project.IsClientAttachmentsRequired;
          this.IsOverTimeApplicable = project.IsOverTimeApplicable;

          // this.IsSunday = project.IsSunday;
          // this.IsMonday = project.IsMonday;
          // this.IsTuesday = project.IsTuesday;
          // this.IsWednesday  = project.IsWednesday;
          // this.IsThursday  = project.IsThursday;
          // this.IsFriday  = project.IsFriday;
          // this.IsSaturday  = project.IsSaturday;
          this.IsAllowFutureDate = project.AllowFutureDatesInTimesheets;
          this.isTaskMandatory = project.MandateTasksInTimesheets;
          this.MaximumRegulerTimesheetHours=project.MaximumRegulerTimesheetHours
          }
          //  else
          // {
            
          //   this.getTimeSheetSettings()
          // }
           
        }
        else if(res.data.State == false){
          this.projectList = res.data.ProjectList
          this.projectSelected = ''
          this.showProjectOptions = false;
        }
        if(this.projectSelected != null && this.projectSelected != ''){
         this.onProjectSelected(this.projectSelected)
        }
        this.getProjectOptionList()
        this.onProjectChangeDataUpdate()
        this.$loading({}).close();
      })
    },
    onProjectChangeDataUpdate()
    {
      if(this.DetailMode)
      {
       this.WorkSheets.forEach((t) => {
         var isWeekday = this.IsWeekDay(t.Date);
          Vue.set(t, 'IsWeekDay', isWeekday)
        })
      }
      else
      {
        this.QuickModeWorkSheets.forEach((m) => {
          m.forEach((t) => {
          var isWeekday = this.IsWeekDay(t.Date);
          Vue.set(t, 'IsWeekDay', isWeekday)
          })
        })
      }
    },
    getTimesheetDetails(){
       this.$loading({'loadingText': 'Loading...'})
      ajax.get(`TimeSheets/Detail/${this.timesheetId}?employeeId=${this.TimesheetEmployeeId}`, {} ,(res) => {
        if(res.data.State == true){
          this.timeSheetDetails = res.data.TimeSheetDetailModel

          //  this.Attachments = this.Attachments.splice(0)

          //  this.ExpenseModel =  res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel
          if(res.data.TimeSheetDetailModel.Attachments != null){
            this.Attachments = res.data.TimeSheetDetailModel.Attachments
            this.Attachments = this.Attachments.splice(0)
            }
           if(res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel != undefined && res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel != null)
           {
           this.ExpenseModel =  res.data.TimeSheetDetailModel.ExpenseDetailModel.ExpenseModel
           this.ExpenseStatus = res.data.TimeSheetDetailModel.ExpenseDetailModel.Status
           }

           this.DetailMode = !res.data.TimeSheetDetailModel.IsQuickMode

           this.ProjectName = res.data.TimeSheetDetailModel.ProjectName ;
           this.EndClientName = res.data.TimeSheetDetailModel.EndClientName;

           this.IsOverTimeApplicable = this.timeSheetDetails.IsOverTimeApplicable;
           this.plannedActivities = res.data.TimeSheetDetailModel.PlannedActivities;
           this.currentPeriodActivities = res.data.TimeSheetDetailModel.CurrentPeriodActivities;
          this.Comments = res.data.TimeSheetDetailModel.Comments;
           this.employmentStartDate = this.timeSheetDetails && this.timeSheetDetails.EmploymentStartDate ? moment(this.timeSheetDetails.EmploymentStartDate).format('MM/DD/YYYY') : '';
           this.assignDetails()
          //  const details = this.timeSheetDetails;
          // const hasDetails =
          //   details &&
          //   (details.PlannedActivities || details.CurrentPeriodActivities);

          // if (hasDetails) {
          //   this.formPlannedActivities = details.PlannedActivities || '';
          //   this.formCurrentPeriodActivities = details.CurrentPeriodActivities || '';
          // } else {
          //   this.formPlannedActivities = this.plannedActivities;
          //   this.formCurrentPeriodActivities = this.currentPeriodActivities;
          // }
          this.getProjectList();
        }
      })
    },
    assignDetails(){
      this.IsWeekendChecked = this.timeSheetDetails.IsWeekendChecked
      this.projectSelected = this.IsNullOrEmpty(this.timeSheetDetails.ProjectSelected) ? "Project unavailable" : this.timeSheetDetails.ProjectSelected;
      this.dateFrom = this.timeSheetDetails.FromDate;
      this.dateTo = this.timeSheetDetails.ToDate;
      // this.SubmitType = this.timeSheetDetails.SubmitType
       this.getWorkSheets();
      var workSheets = this.timeSheetDetails.WorkSheets
      let arrayofDates = [...new Set(workSheets.map(item => item.Date))];
      for(var i=0 ;i < arrayofDates.length ; i++ )
      {
        this.workingDaysList.push( {
          Date:'',
          DayType:workSheets[i].DayType,
          totalTime:'',
          tasksList:[],
          show:true
        })
        var objectbyDate = workSheets.filter(v=>v.Date == arrayofDates[i])
        this.workingDaysList[i].Date = arrayofDates[i]

        for(var j=0 ; j < objectbyDate.length; j++)
        {
          var task = this.taskOptions.data.find(x=>x.id == objectbyDate[j].TaskId);
          var obj =
          {
            Date: objectbyDate[j].Date,
            Hours:objectbyDate[j].Hours.toString(),
            Minutes:objectbyDate[j].Minutes.toString(),
            ProjectId:objectbyDate[j].ProjectId,
            TaskId:objectbyDate[j].TaskId,
            TaskDescription: task != null ? task.description : '',
            OverTimeHours:objectbyDate[j].OverTimeHours ? objectbyDate[j].OverTimeHours.toString():'0',
            OverTimeMinutes:objectbyDate[j].OverTimeMinutes ? objectbyDate[j].OverTimeMinutes.toString() : '0',
          }
          this.workingDaysList[i].tasksList.push(obj)
        }
      }
    },

    getTaskList(){
      this.showTaskSelect2 = false
      ajax.get(`Employee/${this.TimesheetEmployeeId}/BasicTaskDetails?orgId=${this.loggedInUserObj.orgId}`,{},(res)=>{
        this.taskTitleList = res.data.TaskMetaData
        this.isTaskMandatory = res.data.IsTimesheetDetailMode
        this.showTaskSelect2 = true
        this.taskOptions.data = __.map(res.data.TaskMetaData, (t) => {
          return { 'id': t.TaskId, 'text': t.Title,'description':t.Description,'createdByEmail':t.CreatedByEmail,'createdById':t.CreatedById }
        })
      })
    },
    HoursValidation()
    {
      let y = false;
      for(var i=0 ; i < this.WorkSheets.length ; i ++ )
      {
        y = y || this.totalHoursvalidation(this.WorkSheets[i],2) || this.compareMaxHours(this.WorkSheets[i],2)
      }
      return y;
    },
    // isWeekDays(item)
    // {
    //   var dt = new Date(item.Date);
    //   if(dt.getDay() == 0 || dt.getDay() == 6){
    //     return false
    //   }
    //   else{
    //     return true
    //   }
    // },
    isValid(){
      if(!this.DetailMode && this.SubmitType != 'ExpensesOnly')
      {
        this.FormatWorkItemsForDetailMode();
      }
      if(this.SubmitType != 'TimesheetOnly' && this.WorkSheets != null && this.WorkSheets != "" && this.WorkSheets.length > 0){
        this.$refs.timesheetExpenses.saveExpenses();
      }
      this.validateAttachments();
      this.$v.dateFrom.$touch();
      this.$v.dateTo.$touch();
      // this.$v.WorkSheets.$touch();
      this.$v.projectSelected.$touch();
      if(this.isTaskMandatory){
      this.$v.plannedActivities.$touch();
      }
      if(!this.DetailMode && this.isTaskMandatory){
      this.$v.currentPeriodActivities.$touch();
      }
      let x = false
      let isPlannedValid = !this.$v.plannedActivities.$error;
      let isCurrentValid = !this.$v.currentPeriodActivities.$error;      

      let isActivityValid = false;
      let QuickHoursvalidation = false; 
      let hoursValidation = this.HoursValidation();
      if(this.SubmitType != 'ExpensesOnly'){
      if (this.DetailMode) {
        isActivityValid = isPlannedValid;
      } else {
        isActivityValid = isPlannedValid && isCurrentValid;
      }
      if(!this.DetailMode)
      {
        QuickHoursvalidation =  this.$refs.quicktimesheets.IsValid;
      }
      if(this.DetailMode){
      for(var i=0 ; i < this.WorkSheets.length ; i ++ )
      {
         if(this.WorkSheets[i].IsWeekDay)
         {
          if((!this.AllowTimeSheetSubmissionOnHolidays) && (this.WorkSheets[i].DayType == 'FederalHoliday' || this.WorkSheets[i].DayType == 'Holiday')){
            x = false
          }
          else if ((!this.AllowTimeSheetSubmissionOnLeaves) && (this.WorkSheets[i].DayType == 'Leave')) {
              x = false
            }
          else{
            for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j ++ )
            {
              var y = false
              y = this.$v.WorkSheets.$each[i].tasksList.$each[j].Hours.$error || this.$v.WorkSheets.$each[i].tasksList.$each[j].Minutes.$error || this.$v.WorkSheets.$each[i].tasksList.$each[j].TaskId.$error
              x = x || y
            }
          }
         }
      }
     }
     if(!this.DetailMode){
     for(var i=0 ; i < this.WorkSheets.length ; i ++ )
      {
         if(this.WorkSheets[i].IsWeekDay)
         {
          if((!this.AllowTimeSheetSubmissionOnHolidays) && (this.WorkSheets[i].DayType == 'FederalHoliday' || this.WorkSheets[i].DayType == 'Holiday')){
            x = false
          }
          else if ((!this.AllowTimeSheetSubmissionOnLeaves) && (this.WorkSheets[i].DayType == 'Leave')) {
              x = false
          }
          else{
           for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j ++ )
            {
              var y = false
              y = this.$v.WorkSheets.$each[i].tasksList.$each[j].Hours.$error || this.$v.WorkSheets.$each[i].tasksList.$each[j].Minutes.$error
              x = x || y
            }
           }
         }
      }
     }
    }
     if(this.SubmitType == 'ExpensesOnly'){
       if(!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false &&  this.$v.projectSelected.$error == false && this.isExpensesValid){
          this.sendForApproval()
       }
     }
     else if(this.SubmitType == 'TimesheetOnly'){
       if(!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false &&  this.$v.projectSelected.$error == false &&  !this.isValidate && !hoursValidation && !QuickHoursvalidation && isActivityValid){
         if(this.taskExistForTimesheet())
            {
                this.openEvaluationPopup();
            }
            else{
               this.sendForApproval()
            }
       }
     }
     else{
       if(!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false &&  this.$v.projectSelected.$error == false &&  !this.isValidate && this.isExpensesValid && !hoursValidation && !QuickHoursvalidation && isActivityValid){
         if(this.taskExistForTimesheet())
            {
                this.openEvaluationPopup();
            }
            else{
               this.sendForApproval()
            }
       }
     }
      // if(!x && this.$v.dateFrom.$error == false && this.$v.dateTo.$error == false && this.$v.projectSelected.$error == false && !this.isValidate && this.isExpensesValid && !hoursValidation && !QuickHoursvalidation){
      //       if(this.taskExistForTimesheet())
      //       {
      //           this.openEvaluationPopup();
      //       }
      //       else{
      //          this.sendForApproval()
      //       }
      // }
      // else{
      // }
    },
    taskExistForTimesheet()
    {
      let workSheets = [];

      for(var i = 0 ; i < this.WorkSheets.length ; i ++)
      {
        for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j++)
        {
          if(this.projectSelected == 'Project unavailable'){
            this.WorkSheets[i].tasksList[j].ProjectId = "";     
          }
          else{
            this.WorkSheets[i].tasksList[j].ProjectId = this.projectSelected
          }
          
          workSheets.push(this.WorkSheets[i].tasksList[j])
        }
      }

      let taskIdList = workSheets.map(item => item.TaskId).filter(item=>item != '' && item != null && item != undefined)

      if(taskIdList.length > 0)
      {
        return true
      }
      else
      {
        return false
      }
    },
    openEvaluationPopup()
    {
        if(this.IsEmployerUpdated())
        {
            this.$loading({'loadingText': 'Loading...'})
            this.EvaluationPreview()
            setTimeout(() => {
                  this.openEvalutionPopup = true;
                  this.$loading({}).close()
            }, 10000)
        }
        else{
             this.openEvalutionPopup = true;
        }
    },
    onEvalutionButtonClick() {
      this.$loading({'loadingText': 'Generating...'})
      if(this.IsEmployerUpdated())
      {
        var i = 0 ;
        let interval = setInterval(() => {
                if(this.iframeURL != null && this.iframeURL != '')
                {
                    this.openEvaluationReport = true
                     this.$loading({}).close()
                     clearInterval(interval);
                }else{
                       i = 1000;
                       console.log(i)
                }
        }, 5000 + i);
      }
      else{
        this.OpenExistingEvaluationReport()
      }
    },
    OpenExistingEvaluationReport()
    {
      this.iframeURL = ''
      this.selectedEventInfo = event;
      //this.$loading({'loadingText': 'Loading...'})
      this.iframeURL = '' ;
      ajax.get(`TimeSheets/Report/${this.selectedReport.TimesheetId}?employeeId=${this.timesheetEmployeeId}`, {} , (res) => {
        if(res.data.State == true){
          this.iframeURL = res.data.ReportUrl  ;//utils.getFilePreviewLink(res.data.ReportUrl)
          this.openEvaluationReport = true
        }
        this.$loading({}).close()
      })
    },
    EvaluationPreview()
    {
      this.iframeURL = ''
      var workSheets = [];
      if(!this.DetailMode)
      {
         this.FormatWorkItemsForDetailMode();
      }
      for(var i = 0 ; i < this.WorkSheets.length ; i ++)
      {
        for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j++)
        {
          if(this.projectSelected == 'Project unavailable'){
          this.WorkSheets[i].tasksList[j].ProjectId = ""
          }
          else
          {
            this.WorkSheets[i].tasksList[j].ProjectId = this.projectSelected
          }
          workSheets.push(this.WorkSheets[i].tasksList[j])
        }
      }
        var Obj = {
        "Id": this.timesheetId,
        "EmployeeId": this.TimesheetEmployeeId,
        "OrganizationId": this.OrganisationId,
        "FromDate": this.dateFrom,
        "ToDate": this.dateTo,
        "WorkSheets" : workSheets,
        "Attachments" :this.Attachments,
        "ProjectSelected":this.projectSelected,

      }
      ajax.put(`TimeSheets/PreviewEvaluationReport`, Obj ,(res) => {
        if(res.data.State == true) {
          this.iframeURL = res.data.ReportUrl  ;//utils.getFilePreviewLink(res.data.ReportUrl)
          // this.openEvaluationReport = true
        }
        else if(res.data.State == false){
        //  alert('no report')
        }
      })
    },
    sendForApproval(evalutionObj){
      this.$loading({'loadingText': 'Loading...' })
      var workSheets = [];
      for(var i = 0 ; i < this.WorkSheets.length ; i ++)
      {
        for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j++)
        {
          if(this.projectSelected == 'Project unavailable'){
            this.WorkSheets[i].tasksList[j].ProjectId = ""
          }
          else
          {
            this.WorkSheets[i].tasksList[j].ProjectId = this.projectSelected
          }
          this.WorkSheets[i].tasksList[j].ProjectId = this.projectSelected
          workSheets.push(this.WorkSheets[i].tasksList[j])
        }
      }


      // let expenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
      let expenseModel = ''
      if(this.SubmitType != 'TimesheetOnly'){
        expenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
      }
      else {
        expenseModel = ''
      }
      var expenseObject =
      {
        // TimeSheetId:this.timesheetId,
        ExpenseId:this.selectedReport.ExpenseId,
        EmployeeId:this.TimesheetEmployeeId,
        ProjectId:this.projectSelected,
        ExpenseModel:expenseModel,
      }
      var Obj = {
        "Id": this.timesheetId,
        "EmployeeId": this.TimesheetEmployeeId,
        "OrganizationId": this.OrganisationId,
        "FromDate": this.dateFrom,
        "ToDate": this.dateTo,
        "WorkSheets" : workSheets,
        "Attachments" :this.Attachments,
        "ProjectSelected":this.projectSelected,
        "ExpenseDetailModel":expenseObject,
        "IsWeekendChecked":this.IsWeekendChecked,
        "Type": this.SubmitType== "TimesheetAndExpenses" ? "TimesheetExpense" :  this.SubmitType == "TimesheetOnly" ? "Timesheet": "Expense",
        "Comments":this.Comments,        
        "PlannedActivities": this.plannedActivities,
        "CurrentPeriodActivities": this.currentPeriodActivities
      }
      var _this = this;
      ajax.put(`TimeSheets/Verify`, Obj ,(res) => {
        if(res.data.State == true) {
          if(evalutionObj != undefined && evalutionObj != null)
          {
            this.EvaluatTimesheet(evalutionObj,Obj)
          }
          else{
                this.$loading({}).close();
               this.$message({
                type: 'success',
                //message: 'Timesheet(s) approved successfully'
                message:this.SubmitType== "TimesheetAndExpenses" ? "Timesheet(s) and Expense(s) approved successfully" :  this.SubmitType == "TimesheetOnly" ? "Timesheet(s) approved successfully": "Expense(s) approved successfully",
                });

              if(_this.fromTab != 'ListView')
              {
                this.timesheetLocalObject(Obj, this.WorkSheets)
              }
              this.cancel();
          }
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
      })
    },
    timesheetLocalObject(obj,workItems)
    {
       let hoursObj = __.map(workItems, (t) => {
          return { 'Date': t.Date, 'Hours': t.totalTime}
        })
       let totalHoursWorked = this.DetailMode ? this.TotalHoursWorked : this.QuickModeTotalHours;
       let expanseAttachments =  obj.ExpenseDetailModel != null && obj.ExpenseDetailModel.ExpenseModel != null && obj.ExpenseDetailModel.ExpenseModel != '' && obj.ExpenseDetailModel.ExpenseModel.map(v=>v.AttachmentUrls) != null && obj.ExpenseDetailModel.ExpenseModel.map(v=>v.AttachmentUrls).flat();
       let timesheet =
       {
         HoursPerDay: hoursObj,
         IsPagefullLoad : true,
         Id  : obj.Id,
         type : 'Timesheet',
         EmployeeId : obj.EmployeeId,
         Status : "Approved",
         HoursWorked : totalHoursWorked,
         TimesheetAttachments:obj.Attachments,
         ExapnseAmount:this.totalExpensesAmount,
         ExpanseAttachments:expanseAttachments
       }
       this.$parent.refetchEvents(timesheet)
    },
    OnSkipEvaluate()
    {
        this.sendForApproval();
    },
    EvaluatTimesheet(Obj,timesheetObj)
    {
        let _this = this;
        ajax.post(`/TimeSheets/Evaluate`, Obj ,(res) =>{
          if(res.data.State == true){
              this.$message({
              type: 'success',
              message:"Timesheet approved & evaluated successfully"
            });
            if(_this.fromTab != 'ListView')
            {
              this.timesheetLocalObject(timesheetObj, this.WorkSheets)
            }
            this.$loading({}).close();
            this.cancel();
          }
          else{
            this.$message({
              type: 'error',
              message: res.data.Message
            });
          }
        })
    },
    cancel(){
      this.iframeURL = '';
     if (this.$route.name == "employer-timesheets") {
        this.$parent.onEmployerEditTimesheetClose()
      }
      else if (this.$route.name == "timesheets-list"){
          this.$parent.$parent.reLoadData()
      }
    },
    onDateChangeResetData()
    {
      for(var i=0 ; i < this.WorkSheets.length ; i++)
      {
        for(var j=0 ; j < this.workingDaysList.length ; j++)
        {
          if(moment(this.WorkSheets[i].Date).format('MM/DD/YYYY') == moment(this.workingDaysList[j].Date).format('MM/DD/YYYY') )
          {
            this.WorkSheets[i].Date = this.workingDaysList[j].Date
            this.WorkSheets[i].DayType = this.workingDaysList[j].DayType
            this.WorkSheets[i].totalTime = this.workingDaysList[j].totalTime
            this.WorkSheets[i].tasksList = this.workingDaysList[j].tasksList
          }
        }
      }
      if(!this.DetailMode)
      {
        this.FormatWorkItemsForQuickMode()
      }
      this.caliculateTotalTime();
    },
    getWorkSheets(){
      this.keyValueUpdate++;
      this.$loading({ 'loadingText': 'Loading...' })
      ajax.get(`TimeSheets/WorkingDays/${this.TimesheetEmployeeId}/${this.OrganisationId}?fromDate=${this.dateFrom}&toDate=${this.dateTo}&timeSheetId=${this.timesheetId}`, {} ,(res) => {
        if(res.data.State == true){
          this.directHoursEntered = ""
          if(this.WorkSheets.length > 0)
          {
            this.workingDaysList = []
            this.workingDaysList =  this.WorkSheets
          }
         // this.IsCoincide = res.data.IsCoincide
          this.IsWorkingDaysAvailable = res.data.IsWorkingsDaysAvailable
          this.coinsideDateFrom = res.data.FromDate
          this.coinsideDateTo = res.data.ToDate
         // if(!this.IsCoincide)
          {
               this.WorkSheets = __.map(res.data.WorkingDaysList, (t) => {
                var isWeekday = this.IsWeekDay(t.Date); 
                var tasksList = [{
                    ProjectId:'',
                    TaskId:'',
                    Date:t.Date,
                    Hours:'',
                    Minutes:'',
                    OverTimeHours:'',
                    OverTimeMinutes:'',
                    TaskDescription:'',
                    IsTaskEdited:false,
                  }];
                return {'Date' : t.Date ,'DayType':t.DayType,'totalTime':'0 Hours', 'tasksList': tasksList,show:true, IsWeekDay:isWeekday }
                })
                this.onDateChangeResetData()
                this.$loading({}).close()
          }
        }
      })
    },
     IsWeekDay(date)
    {
       var day = moment(date).format('dddd');
       if(day == 'Sunday' && this.IsSunday)
       {
         return true;
       }
       else if(day == 'Monday' && this.IsMonday)
       {
         return true;
       }
       else if(day == 'Tuesday' && this.IsTuesday)
       {
         return true;
       } 
       else if(day == 'Wednesday' && this.IsWednesday)
       {
         return true;
       } 
       else if(day == 'Thursday' && this.IsThursday)
       {
         return true;
       } 
       else if(day == 'Friday' && this.IsFriday)
       {
         return true;
       } 
       else if(day == 'Saturday' && this.IsSaturday)
       {
         return true;
       }
       return false;
    },
    callDateRange(){
      if(this.dateFrom != '' && this.dateTo != ''){
        this.getWorkSheets();
         this.getWorkHoursPerDay();
      }
    },
    getDayFormat(date){
      var day = moment(date).format('dddd')
      return day
    },
    getDateFormat(date){
      var date1 = moment(date).format('Do');
      var month = moment(date).format('MMM')
      return date1 +" "+ month
    },

    onAddAtachment()
    {
      this.showAttachmentDiv = true
      this.open()
    },
    getFileName(item)
    {
      var filename = utils.I9URL2FileName(item);
      var fileLength = filename.length
      if(fileLength > 33)
      {
      return filename.substring(0,30) + "...";
      }
      else return filename
    },
    isFileType(item)
      {
        var filename = utils.I9URL2FileName(item);
        var fileExtention = filename.split('.').pop();
        var FileTypes = ["pdf", "png", "gif", "jpg", "jpeg"];
        return FileTypes.includes(fileExtention)
      },
    open() {
      setTimeout(() => {
        this.$refs.upload.uploadNew();
      }, 1000)
    },
    IsInvalidFile(error)
    {
      if(error != '')
      {
        this.$message({
          type: 'error',
          message: error
        });
      }
    },
    InProgress()
    {
      this.$loading({'loadingText': 'Loading...'})
      this.showAttachmentDiv = true
    },
    onuploadComplete(v) {
      for(var i=0 ; i<v.length ; i++)
      {
        if (v[i].response.Url != null)
          this.Attachments.push(v[i].response.Url)
           this.isErrorMessageDisabled = false
        }
        if (v[0].response.State == false && v[0].response.Message != null)
        {
          this.iCounter++
          this.isErrorMessageDisabled = true
          this.errorMessageFrmResponse = v[0].response.Message
      }
      this.showAttachmentDiv = false
       this.validateAttachments();
      this.$loading({}).close();
    },
    removeAttachments(index){
      this.$alert2(`Are you sure you want to delete ?`, "Alert", {
          type: "confirm",
          yesButtonText: "Yes",
          noButtonText: "No",
          callback: (action) => {
            if(action === true) {
              this.Attachments.splice(index , 1)
            }
          }
         })
    },
    select2close(index,Index,type,val)
    {
      // on select 2 close..caliculating total hours for the date.
      this.calculateHours(index,Index,type,val);
    },
    caliculateTotalTime()
    { //total time for respective date for All worksheets
      for(var i = 0 ; i < this.WorkSheets.length ; i ++)
      {
        var selectedHours = 0
        var selectedMinutes = 0

        for(var j=0 ; j < this.WorkSheets[i].tasksList.length ; j++)
        {
          if(this.WorkSheets[i].tasksList[j].Hours != '' && this.WorkSheets[i].tasksList[j].Hours != null){
            selectedHours = parseInt(selectedHours) + parseInt(this.WorkSheets[i].tasksList[j].Hours) + (parseInt(this.WorkSheets[i].tasksList[j].OverTimeHours) || 0) ;
          }
          if(this.WorkSheets[i].tasksList[j].Minutes != '' && this.WorkSheets[i].tasksList[j].Minutes != null){
            selectedMinutes = parseInt(selectedMinutes) + parseInt(this.WorkSheets[i].tasksList[j].Minutes) + ( parseInt(this.WorkSheets[i].tasksList[j].OverTimeMinutes) || 0) ;
          }
        }
        var hours = (selectedMinutes / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        this.Hours = 0;
        this.Minute = 0;
        var totalHours = parseInt(selectedHours) + parseInt(rhours)
        this.WorkSheets[i].totalTime = totalHours +"h " + rminutes + "m"
      }
    },
    calculateHours(index,Index,type,val){
      //total time for respective date for one worksheets
        var selectedHours = 0
        var selectedMinutes = 0

        for(var j=0 ; j < this.WorkSheets[index].tasksList.length ; j++)
        {
         //if(this.WorkSheets[index].tasksList[j].Hours != '' && this.WorkSheets[index].tasksList[j].Hours != null){
            selectedHours = parseInt(selectedHours) + parseInt(this.WorkSheets[index].tasksList[j].Hours) + (parseInt(this.WorkSheets[index].tasksList[j].OverTimeHours) || 0) ;
         //}
         //if(this.WorkSheets[index].tasksList[j].Minutes != '' && this.WorkSheets[index].tasksList[j].Minutes != null){
            selectedMinutes = parseInt(selectedMinutes) + parseInt(this.WorkSheets[index].tasksList[j].Minutes) + ( parseInt(this.WorkSheets[index].tasksList[j].OverTimeMinutes) || 0) ;
         //}
        }
        var hours = (selectedMinutes / 60);
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        this.Hours = 0;
        this.Minute = 0;
        var totalHours = parseInt(selectedHours) + parseInt(rhours)
        this.WorkSheets[index].totalTime = (parseInt(totalHours) || 0) +"h " + (parseInt(rminutes) || 0)+ "m";
    },
    getWorkHoursPerDay(){
      var empId = this.EmployeeId;
      if(this.$route.query.from == 'employer-timesheets')
      {
         empId = this.selectedEmployeeID
      }
      ajax.get(`TimeSheets/WorkHoursPerDay?employeeId=${empId}&fromDate=${this.dateFrom}&toDate=${this.dateTo}&timeSheetId=${this.timesheetId}&projectId=${this.projectSelected}`, {} ,(res) => {
        if(res.data.State == true){          
          this.PreviousWorkHours = res.data.hoursPerDay
        }
      })
    },
    getTimeSheetSettings(){
      this.$loading({'loadingText': 'Loading...'}) 
      ajax.get(`TimeSheets/Settings?orgId=${this.loggedInUserObj.orgId}`, {} , (res) => {
        if(res.data.State == true){
          if(res.data.TimesheetSettings != null){
            // this.IsAllowFutureDate = res.data.TimesheetSettings.AllowFutureDatesInTimesheets
            // this.isTaskMandatory  = res.data.TimesheetSettings.MandateTasksInTimesheets
            this.AllowTimeSheetSubmissionOnHolidays = res.data.TimesheetSettings.AllowTimeSheetSubmissionOnHolidays
            this.AllowTimeSheetSubmissionOnLeaves = res.data.TimesheetSettings.AllowTimeSheetSubmissionOnLeaves

            if(res.data.TimesheetSettings.TimesheetSubmitDays != null)
            {
                this.IsSunday = res.data.TimesheetSettings.TimesheetSubmitDays.IsSunday
                this.IsMonday = res.data.TimesheetSettings.TimesheetSubmitDays.IsMonday
                this.IsTuesday = res.data.TimesheetSettings.TimesheetSubmitDays.IsTuesday
                this.IsWednesday = res.data.TimesheetSettings.TimesheetSubmitDays.IsWednesday
                this.IsThursday = res.data.TimesheetSettings.TimesheetSubmitDays.IsThursday
                this.IsFriday = res.data.TimesheetSettings.TimesheetSubmitDays.IsFriday
                this.IsSaturday = res.data.TimesheetSettings.TimesheetSubmitDays.IsSaturday
            }
            if(res.data.TimesheetSettings.AllowFutureDatesInTimesheets != null && res.data.TimesheetSettings.AllowFutureDatesInTimesheets != undefined){
              this.IsAllowFutureDate = res.data.TimesheetSettings.AllowFutureDatesInTimesheets.PreferenceApplied
            }
            if(res.data.TimesheetSettings.MandateTasksInTimesheets != null && res.data.TimesheetSettings.MandateTasksInTimesheets != undefined){
              this.isTaskMandatory = res.data.TimesheetSettings.MandateTasksInTimesheets.PreferenceApplied
            }
          }
        }
        else{
          this.$message({
            type: 'error',
            message: res.data.Message
          })
        }
        this.$loading({}).close()
      })
    },
    OnselectedTimesheetType(type)
    {
      let expenseModel = [];
      if(this.SubmitType != 'TimesheetOnly'){
      if(this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null){
        expenseModel = this.$refs.timesheetExpenses.formatTimesheetExpanseObjectToSave();
      }
      }
      if(type == 'ExpensesOnly')
      {
          if(expenseModel != null && expenseModel != undefined && expenseModel.length == 0)
          {
            this.ExpenseModel.push({
              Id:'',
              ExpenseType:'',
              ExpenseAmount:'',
              ExpenseDetails:'',
              PaymentType:'CompanyPaid',
              AttachmentUrls:[],
              SpecifyReason :'',
              isAttachementreq : false,
            })
            if(this.$refs.timesheetExpenses != undefined && this.$refs.timesheetExpenses != null){
              this.$refs.timesheetExpenses.formatTimesheetExpanseObjectForGet()
            }
          }
      }
      else if(type == 'TimesheetAndExpenses'){
        if(expenseModel != null && expenseModel != undefined && expenseModel.length == 0 &&  this.$refs.timesheetExpenses != undefined)
          {
             this.$refs.timesheetExpenses.formatTimesheetExpanseObjectForGet()
          }
      }
    },
     guid(){
      function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
        .toString(16)
        .substring(1);
      }
      return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
              s4() + '-' + s4() + s4() + s4();
    },
    bindingReqObjectForAddTask(title,sheetIndex, taskIndex){
      var list = []
        var taskListObj = {}
        var Obj = {}
        var empId = this.timesheetEmployeeId
        var empList = []
        
         
            empList.push(empId)
          Obj =  {
            "TaskId": this.guid(),
            "Title": title,
            "Description":'',
            "CreatedDate": moment().format('MM/DD/YYYY'),
            //"CreatedBy": this.CreatedByList[createdBySelectedIndex],
            "Hours": '',
            "Minutes": '',
            "EmployeeIdList": empList
          }
          list.push(Obj)
        
        taskListObj = {
          "Data": list
        }
        this.addTask(taskListObj)
        this.taskOptions.data.push({'id': Obj.TaskId, 'text' : Obj.Title})
        this.WorkSheets[sheetIndex].tasksList[taskIndex].TaskId = Obj.TaskId

    },
    addTask(obj){
      ajax.post(`/Task/Add`,obj, (res) => {
        if(res.data.State == true) {
          this.$message({
            type: 'success',
            message: "Task Added Successfully"
          });
          this.$loading({}).close();
        }else if(res.data.State == false){
          this.$loading({}).close();
          this.$message({
              type: 'error',
              message: res.data.Message
          });
        }
      });
    },
    fromDateValidation(val) {
      var project = [];
      if (this.projectList.length > 0) {
        project = this.projectList.filter(v => v.ProjectId == this.projectSelected)[0]
        if (project != "" && project != null) {
          var projectStartDate = moment(project.ProjectStartDate);
          var fromMinDate;
          if(this.employmentStartDate) {
            var employmentStartDate = moment(this.employmentStartDate)
            fromMinDate = employmentStartDate.isBefore(projectStartDate) ? projectStartDate : employmentStartDate
          }
          else {
            fromMinDate = projectStartDate
          }
          setTimeout(() => {
            if (!this.IsAllowFutureDate && val != "dateTo") {
            this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
            }
            else if(this.IsAllowFutureDate){
            this.$refs.dateFrom.data.minDate(fromMinDate.format('MM/DD/YYYY'))
            }
          }, 600)
        }
        else {
          setTimeout(() => {
            this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
          }, 100)
        }
      }
      else {
          setTimeout(() => {
            this.employmentStartDate ? this.$refs.dateFrom.data.minDate(moment(this.employmentStartDate).format('MM/DD/YYYY')) : ''
          }, 100)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.toggle-span{
    display: inline-block;
    background:#fff;
    border: 2px solid #DFDFDF;
    border-radius: 5px;
    font-weight: 600;
    float: right;
    .toggle-btn{
         border: 0;
         color: white;
         height: 28px;
         width: 70px;
    }
    .btn-toggle-selected{
      color:white;
      background-color: #143361;
      border-radius: 5px;
      margin: 2px;
    }
    .btn-toggle-un-selected{
      background-color:white;
      color: rgb(133, 149, 166);
    }
 }
 .add-timesheets{
    height:100%;
    overflow-y:auto;
    overflow-x: hidden;
  }
  .validation-star{
    color: #F31D1D;
  }
  .duration{
    width: 0px;
    font-size: 11px;
    font-weight: 600;
    color:#464444;
    margin-top: 1px;
    padding-right: 27px !important;
    height: 28px;
    display: inline-block;
    float: left;
  }
  .select2_style{
    width: 55px;
   display: inline-block;
  }
  .holiday{
    color:#333333;
    text-align: center;
    font-weight: 600;
    font-style: italic;
  }
  .attachments_view{
      p{
        font-weight: 600;
      }
    .form-group {
      margin-left: -16px;
      margin-top: 15px;
      label{
          font-weight: 600;
          font-size: 11px;
      }
    }
    .attachments-view
    {
      margin-bottom: 5px;
      margin-left: 0px;
      border: 1px solid #4A90E2 !important;
      background: #e6eff9  !important;
      padding: 4px 4px 4px 10px;
      display: inline-block;
      border-radius: 30px;
      font-weight: 600;
      float: left;
      margin-right: 2%;
      font-size: 11px;
    }
    .cross-mark{
      font-size: 15px;
      padding: 0px 5px;
      border-radius: 100%;
      cursor: pointer;
    }
    .cross-mark:hover{
      background:  #c2c2c2;
      padding: 0px 5px;
      border-radius: 100%;
      text-decoration: none !important;
    }
     .task-title:hover
    {
        color:#4A90E2;
        cursor: pointer;
    }
  }
  .timesheet_lable{
      color:#464444;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 230px;
      overflow: hidden;
     //margin-top: 5px;
      font-weight: 600;
    }
    .add_timesheets-body{
      margin-bottom: 15px
    }
    .cursorCls
    {
      cursor:not-allowed !important;
    }
    .hideShow
    {
      pointer-events: none !important;
    }
    .disabled-day{
    background: #FDF2F3; cursor: default;  border: 0;  padding: 15px;font-weight: bold; font-size: 12px;cursor: not-allowed;
    }
    .descriptn{
      display: block;
      width: 100%;
      height: 80px;
      border-color: #ddd;
      border-radius: 5px;
      padding: 10px;
      resize: none;
      margin-top: 10px;
    }
    .disable_textArea{
        margin-top: 10px;
        width: 100%;
        height: 80px;
        padding: 10px;
        resize: none;
        cursor: not-allowed;
        background-color: #eee !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/Calender/ApprovalFlow/EmployerEditTimesheet.vue